import moment from "moment-timezone";
import Swal from "sweetalert2/dist/sweetalert2.js";
import {
  IoIosAddCircle,
  IoIosRemoveCircle,
  IoIosCalculator,
  IoMdDoneAll,
} from "react-icons/io";
import {
  BiRupee,
  BiDownArrowAlt,
  BiLocationPlus,
  BiFlag,
  BiPaperclip,
  BiRightArrowAlt,
  BiCommentDetail,
} from "react-icons/bi";
import { MdLibraryAdd, MdVerifiedUser } from "react-icons/md";
import { TiThList } from "react-icons/ti";
import { HiViewGridAdd } from "react-icons/hi";
import { CgAttachment } from "react-icons/cg";
import {
  RiShareForwardFill,
  RiArrowGoBackFill,
  RiUserShared2Line,
  RiUserReceivedLine,
  RiUser3Line,
  RiEditBoxFill,
  RiPrinterFill,
  RiFileExcel2Fill,
  RiSendPlaneFill,
  RiCheckboxMultipleBlankFill,
  RiUpload2Fill,
  RiCloseFill,
} from "react-icons/ri";
import {
  FaFilePdf,
  FaRegCopy,
  FaEdit,
  FaCalendarAlt,
  FaTrashAlt,
  FaSignOutAlt,
  FaBars,
  FaBookReader,
  FaUserEdit,
  FaUserCheck,
} from "react-icons/fa";
import {
  ImFirst,
  ImLast,
  ImHome3,
  ImArrowLeft,
  ImBoxAdd,
} from "react-icons/im";
import { BsEyeFill } from "react-icons/bs";
import { FiPercent, FiAlignJustify } from "react-icons/fi";
import { GiReturnArrow } from "react-icons/gi";
import { GrNotes, GrFormView } from "react-icons/gr";
import { FcProcess, FcApproval, FcFlowChart } from "react-icons/fc";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AiOutlineExpandAlt } from "react-icons/ai";
import autoTable from "jspdf-autotable";
import { jsPDF } from "jspdf";
import MasterService from "../../Services/MasterService";
// import * as XLSX from "sheetjs-style";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
// import jsPDF from "jspdf";

import Select from "react-select";
import { saveAs } from "file-saver";
import domtoimage from "dom-to-image-more";
import { store } from "../../App";
import KpiService from "../../Services/KpiService";
export const PRINT_ICON = (props) => <RiPrinterFill {...props} />;
export const BACK_ICON = (props) => <ImArrowLeft {...props} />;
export const FW_ICON = (props) => <RiShareForwardFill {...props} />;
export const RETURN_ICON = (props) => <RiArrowGoBackFill {...props} />;
export const APR_ICON = (props) => <IoMdDoneAll {...props} />;
export const COPY_ICON = (props) => <FaRegCopy {...props} />;
export const RUPEE_ICON = (props) => <BiRupee {...props} />;
export const VIEW_ICON = (props) => <BsEyeFill {...props} />;
export const ADDL_ICON = (props) => <MdLibraryAdd {...props} />;
export const BARS_ICON = (props) => <FaBars {...props} />;
export const HOME_ICON = (props) => <ImHome3 {...props} />;
export const CREATE_ICON = (props) => <HiViewGridAdd {...props} />;
export const DRAFT_ICON = (props) => <FaEdit {...props} />;
export const INBOX_ICON = (props) => <ImBoxAdd {...props} />;
export const OUTBOX_ICON = (props) => <FaSignOutAlt {...props} />;
export const LIST_ICON = (props) => <TiThList {...props} />;
export const SEND_ICON = (props) => <RiSendPlaneFill {...props} />;
export const EXECEL_ICON = (props) => <RiFileExcel2Fill {...props} />;
export const PDF_ICON = (props) => <FaFilePdf {...props} />;
export const FIRST_ICON = (props) => <ImFirst {...props} />;
export const LAST_ICON = (props) => <ImLast {...props} />;
export const EDIT_ICON = (props) => <RiEditBoxFill {...props} />;
export const ADD_ICON = (props) => <IoIosAddCircle {...props} />;
export const REMOVE_ICON = (props) => <IoIosRemoveCircle {...props} />;
export const ATTACH_ICON = (props) => <CgAttachment {...props} />;
export const LOCATION_ICON = (props) => <BiLocationPlus {...props} />;
export const FLAG_ICON = (props) => <BiFlag {...props} />;
export const PAPERCLIP_ICON = (props) => <BiPaperclip {...props} />;
export const CAL_ICON = (props) => <IoIosCalculator {...props} />;
export const COMMENT_ICON = (props) => <BiCommentDetail {...props} />;
export const MODAL_ICON = (props) => <RiCheckboxMultipleBlankFill {...props} />;
export const UPLOAD_ICON = (props) => <RiUpload2Fill {...props} />;
export const CALENDAR_ICON = (props) => <FaCalendarAlt {...props} />;
export const PERCENTAGE_ICON = (props) => <FiPercent {...props} />;
export const NOTES_ICON = (props) => <GrNotes {...props} />;
export const COLLAPSE_ICON = (props) => <BiRightArrowAlt {...props} />;
export const EXPAND_ICON = (props) => <BiDownArrowAlt {...props} />;

export const PROCESS_ICON = (props) => <FcProcess {...props} />;
export const APPROVED_ICON = (props) => <FcApproval {...props} />;
export const RETURNED_ICON = (props) => <GiReturnArrow {...props} />;

export const CLOSE_ICON = (props) => <RiCloseFill {...props} />;
export const MENU_ICON = (props) => <FiAlignJustify {...props} />;
export const MBOOK_ICON = (props) => <FaBookReader {...props} />;
export const SHOW_ICON = (props) => <GrFormView {...props} />;

export const DOC_FLOW_ICON = (props) => <FcFlowChart {...props} />;

export const S_MAKER_ICON = (props) => <FaUserEdit {...props} />;
export const S_FWD_ICON = (props) => (
  <RiUserShared2Line color="#0fa549" {...props} />
);
export const S_CHECKER_ICON = (props) => <FaUserCheck {...props} />;
export const S_RETURN_ICON = (props) => (
  <>
    <RiUserReceivedLine color="red" {...props} />
  </>
);
export const S_FINISH_ICON = (props) => (
  <MdVerifiedUser color="#0fa549" {...props} />
);
export const S_PENDING_ICON = (props) => (
  <RiUser3Line color="#bfbdbd" {...props} />
);
export const EXPANDTABLE_ICON = (props) => <AiOutlineExpandAlt {...props} />;
export const STEP_ICON = (props) => <GiReturnArrow {...props} />;

export const DELETE_ICON = (props) => <FaTrashAlt {...props} />;

export const DOC_FLOW_LINK = (props) => (
  <Link
    className="btn btn-sm btn-primary"
    role="button"
    to={{
      pathname: "/newDocFlow",
      state: {
        workType: props?.workType,
        subWorkType: props?.subWorkType,
        workId: props?.workId,
      },
    }}
    data-tip="Document Flow"
  >
    {" "}
    <DOC_FLOW_ICON /> Doc Flow{" "}
  </Link>
);

export const BACK_LINK = (props) => {
  const { history, onClick } = props;
  return (
    history?.length > 0 && (
      <Button
        size="sm"
        data-tip="Go Back"
        variant="primary"
        onClick={(event) => {
          onClick && onClick(event);
          if (history.length > 1) {
            history.goBack();
          } else {
            history.push("/home");
          }
        }}
      >
        {" "}
        <BACK_ICON /> BACK{" "}
      </Button>
    )
  );
};

export const showNotification = (type, message) => {
  if (type === "success") {
    Swal.fire("Success", message, "success");
  } else if (type === "error") {
    Swal.fire("Error", message, "error");
  } else if (type === "warning") {
    Swal.fire("Warning", message, "warning");
  } else if (type === "info") {
    Swal.fire("info", message, "info");
  }
};

export function roundAmount(value) {
  let amount = (parseFloat(value) || 0).toFixed(2);
  return parseFloat(amount);
}

export function roundOfZeroAmount(value) {
  let amount = (parseFloat(value) || 0).toFixed(0);
  return parseFloat(amount);
}

export function amountFormat(value) {
  let amount = (parseFloat(value) || 0).toFixed(2);
  return parseFloat(amount).toLocaleString("en-IN");
}

export function amountQuantity(value) {
  let amount = (parseFloat(value) || 0).toFixed(4);
  return parseFloat(amount).toLocaleString("en-IN");
}

export function dateFormat(date) {
  return date ? moment(date).format("DD-MMM-YYYY  hh:mm A") : "-";
}

export function dateFormatWithoutTime(date) {
  return date ? moment(date).format("DD-MM-YYYY") : "-";
}

export function roundQuantity(value) {
  let qty = (parseFloat(value) || 0).toFixed(5);
  return parseFloat(qty);
}

export function roundEpcQuantity(value) {
  let qty = (parseFloat(value) || 0).toFixed(10);
  return parseFloat(qty);
}

export function isValidNumber(value) {
  if (value !== "") {
    const pattern = /^(0|[1-9]\d*)$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export const NAME_OF_WORK_LENGTH = 50;

export const remaininCharacters = (count, value) => {
  return <>(Remaining Characters : {count - (value?.length || 0)})</>;
};

export const DETAILS_OF_WORK_LENGTH = 500;
export const DETAILS_OF_WORK_LENGTH2 = 100;

export function OnlyNumbers(value) {
  if (value !== "") {
    var pattern = /^[1-9]\d*(\.\d+(?:\.\d{1,2}))?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export function isValidFloat(value) {
  if (value !== "") {
    var pattern = /^[0-9]+(?:\.)?(\d{1,7})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export function isValidRate(value) {
  if (value !== "") {
    var pattern = /^[0-9]+(?:\.)?(\d{1,2})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export function isValidQuant(value) {
  if (value !== "") {
    var pattern = /^[0-9]+(?:\.)?(\d{1,3})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export function isValidEpcQuant(value) {
  if (value !== "") {
    var pattern = /^[0-9]+(?:\.)?(\d{1,10})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export const NumberValidation = (e) => {
  var keyCode = e.keyCode === 0 ? e.charCode : e.keyCode;
  var value = Number(e.target.value + e.key) || 0;
  if (keyCode >= 48 && keyCode <= 57) {
    return isValidNumber(value);
  } else {
    e.preventDefault();
  }
  return false;
};

export const allowAlphabetAndSpacesOnly = (e) => {
  const keyCode = e.charCode;

  const value = Number(e.target.value + e.key) || 0;

  if (
    !(keyCode >= 65 && keyCode <= 90) && // A-Z
    !(keyCode >= 97 && keyCode <= 122) && // a-z
    keyCode !== 32 && // Space
    keyCode !== 46 && // .
    // keyCode !== 40 &&                      // (
    // keyCode !== 41 &&                      // )
    keyCode !== 0
  ) {
    e.preventDefault();
  } else {
    return value;
  }

  return false;
};
export function isValidPaidQty(value) {
  if (value !== "") {
    var pattern = /^[0-9]+(?:\.)?(\d{1,3})?$/;
    return pattern.test(value);
  } else {
    return true;
  }
}

export function PickerFormat(date) {
  return date ? moment(date).format("DD-MM-yyyy") : "";
}
export const AMOUNT_LENGTH = 12;

export const VALID_TO = moment("31-12-9999", "DD-MM-YYYY").toDate();

export const ADD_YEARS_VALID_TO = (date) => {
  return moment(date).add(5, "years").toDate();
};

export function groupArrayOfObjects(list, key) {
  return list.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}

export const AGREEMENTAMOUNT = 18;

export function FireConfirmationSwal(msg) {
  Swal.fire({
    icon: "question",
    title: "",
    text: msg,
    confirmButtonText: "OK",
    showCancelButton: true,
  }).then((result) => {
    if (result.isConfirmed) {
      return true;
    } else {
      return false;
    }
  });
  return false;
}

export const SumAmount = (array, keyName) => {
  return array.reduce((sum, row) => parseFloat(row[keyName]) + sum, 0);
};

export const NotesRemaininCharacters = (value) => {
  return <>({500 - (value || 0)})</>;
};

export function convertStringToDate(date) {
  return moment(date, "DD-MM-YYYY");
}

export const COLOUR_STATUS = (props) => {
  let obj = { S01: "#ffbf00", S02: "#4fa0b9", S03: "#6fa000", S04: "#ff4c00" };
  return (
    <>
      {" "}
      <p style={{ color: obj[props?.statusCode], fontSize: "20px" }}>
        {" "}
        <b>{props?.statusDesc}</b>{" "}
      </p>{" "}
    </>
  );
};

export default function allowNumbersOnly(e) {
  var keyCode = e.keyCode === 0 ? e.charCode : e.keyCode;
  var value = Number(e.target.value + e.key) || 0;
  if (keyCode >= 48 && keyCode <= 57) {
    return isValidNumbers(value);
  } else {
    e.preventDefault();
  }
  return false;
}

const isValidNumbers = (number) => {
  return 1 <= number && number <= 10;
};

export function ClearLocalStorage() {
  localStorage.removeItem("token");
  localStorage.removeItem("serviceList");
  localStorage.clear();
}

export function istwodecimals(e) {
  if (
    e.key !== "Backspace" &&
    e.key !== "Delete" &&
    e.key !== "." &&
    e.key !== "-" &&
    (isNaN(Number(e.key)) ||
      (e.target.value.includes(".") &&
        e.target.value.split(".")[1].length >= 2))
  ) {
    e.preventDefault();
  }
}

export function isValid(e) {
  const inputValue = e.target.value;
  if (
    (e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "-" &&
      e.key !== "." &&
      (isNaN(Number(e.key)) ||
        (inputValue.includes(".") && inputValue.split(".")[1].length >= 2))) ||
    (e.key === "." && inputValue.includes("."))
  ) {
    e.preventDefault();
  }
}

// export function isValidsix(e) {
//   const inputValue = e.target.value;
//   if (
//     (e.key !== "Backspace" &&
//       e.key !== "Delete" &&
//       e.key !== "-" &&
//       e.key !== "." &&
//       (isNaN(Number(e.key)) ||
//         (inputValue.includes(".") && inputValue.split(".")[1].length >= 6))) ||
//     (e.key === "." && inputValue.includes("."))
//   ) {
//     e.preventDefault();
//   }
// }

export function isValidsix(e) {
  const inputValue = e.target.value;

  if (
    (e.key === "." && inputValue.length === 0) ||
    (e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "-" &&
      e.key !== "." &&
      (isNaN(Number(e.key)) ||
        (inputValue.includes(".") && inputValue.split(".")[1].length >= 6))) ||
    (e.key === "." && inputValue.includes("."))
  ) {
    e.preventDefault();
  }
}

export function generatePdf(tableid, filename, columnsCount) {
  const exportHeaders = document.querySelectorAll(".only-export");
  exportHeaders.forEach((el) => {
    el.style.display = "table-row";
  });

  console.log("columnsCount", columnsCount);

  let format = "a4";
  if (columnsCount > 15) {
    format = "a0";
  } else if (columnsCount > 10) {
    format = "a2";
  } else {
    format = "a3";
  }
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: format,
  });

  autoTable(doc, {
    html: tableid,
    theme: "grid",
    styles: { fontSize: 9 },
    headStyles: { halign: "center" },
    columnStyles: {
      0: { cellWidth: "wrap" },
    },
    didParseCell: function (data) {
      const rawText = data.cell.text?.join(" ")?.trim();

      if (rawText?.startsWith("Report On")) { data.cell.styles.halign = "right"; }

      if (data.cell.raw && data.cell.raw.querySelector("img")) { const img = data.cell.raw.querySelector("img"); data.cell.text = img.getAttribute("alt") || img.getAttribute("data-value") || "Image"; }
    },
  });
  doc.save(`${filename}.pdf`); exportHeaders.forEach((el) => { el.style.display = "none"; });
}

export function generatelargePdf(tableid, filename) {
  const exportHeaders = document.querySelectorAll(".only-export");
  exportHeaders.forEach((el) => {
    el.style.display = "table-row";
  });

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [3000, 3000],
  });

  autoTable(doc, {
    html: tableid,
    theme: "grid",
    tableWidth: "wrap",
    columnStyles: { 3: { cellWidth: "wrap" } },
    styles: { fontSize: 10 },
    headStyles: { halign: "center" },
    didParseCell: function (data) {
      const rawText = data.cell.text?.join(" ")?.trim(); if (rawText?.startsWith("Report On")) { data.cell.styles.halign = "right"; }

      if (data.cell.raw && data.cell.raw.querySelector("img")) { const img = data.cell.raw.querySelector("img"); data.cell.text = img.getAttribute("alt") || img.getAttribute("data-value") || "Image"; }
    },
  });
  doc.save(`${filename}.pdf`); exportHeaders.forEach((el) => { el.style.display = "none"; });
}

export function generateindicatorpdf(filteredData1) {
  if (!Array.isArray(filteredData1) || filteredData1.length === 0) {
    return;
  }

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });
  doc.setFontSize(12);
  doc.text("Mapped Indicators (or) Activity", 14, 15);
  const tableHead = [
    { content: "Slno.", styles: { halign: "center", fontStyle: "bold" } },
    {
      content: "Sub Indicator Name",
      styles: { halign: "center", fontStyle: "bold" },
    },
    { content: "Unit", styles: { halign: "center", fontStyle: "bold" } },
  ];
  const tableBody = [];
  let indexCounter = 1;

  filteredData1.forEach((detail) => {
    if (detail.indicator_name) {
      tableBody.push([
        {
          content: detail.indicator_name,
          colSpan: 3,
          styles: { halign: "center", fontStyle: "bold" },
        },
      ]);
    }

    if (detail.sub_indicator_name) {
      tableBody.push([
        { content: indexCounter, styles: { halign: "center" } },
        { content: detail.sub_indicator_name, styles: { halign: "left" } },
        { content: detail.unit || "", styles: { halign: "center" } },
      ]);
      indexCounter++;
    }
  });

  autoTable(doc, {
    head: [tableHead],
    body: tableBody,
    theme: "grid",
    styles: { fontSize: 8 },
    columnStyles: {
      0: { cellWidth: 15 },
      1: { cellWidth: 100 },
      2: { cellWidth: 50 },
    },
    startY: 20,
  });

  doc.save("Mandal Mapping.pdf");
}

export function exportToExcelindicator(filteredData1) {
  if (!Array.isArray(filteredData1)) {
    return;
  }

  const wsData = filteredData1.map((detail, i) => [
    detail.indicator_name || "",
    detail.sub_indicator_name || "",
    detail.unit || "",
  ]);

  const headers = ["Indicator Name", "Sub Indicator", "Unit"];
  wsData.unshift(headers);

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  XLSX.writeFile(wb, "Mandal Mapping.xlsx");
}

export function exportToExcel(tableId, fileName) {
  const table = document.getElementById(tableId); if (!table) { console.error(`Table with ID ${tableId} not found!`); return; }

  try {
    const sheetName = fileName.length > 31 ? fileName.substring(0, 31) : fileName; const rows = []; const merges = []; const occupied = {}; const maxTextLengths = [];

    const tableRows = Array.from(table.rows);

    tableRows.forEach((row, rowIndex) => {
      const rowData = []; let colIndex = 0;
      while (occupied[`${rowIndex},${colIndex}`]) { colIndex++; }

      Array.from(row.cells).forEach((cell) => {
        const colspan = parseInt(cell.getAttribute("colspan")) || 1; const rowspan = parseInt(cell.getAttribute("rowspan")) || 1; const cellValue = cell.textContent.trim(); const isHeader = row.parentElement.tagName === "THEAD";

        let horizontalAlign = isHeader ? "center" : "left"; if (row.textContent.includes("Report On")) { horizontalAlign = "right"; }
        const alignment = { horizontal: horizontalAlign, vertical: "center", wrapText: true, };
        const cellStyle = { alignment, font: { bold: isHeader, color: { rgb: "000000" } }, };

        rowData[colIndex] = { v: cellValue, s: cellStyle };

        if (colspan === 1) { const estimatedWidth = cellValue.length <= 4 ? cellValue.length + 4 : Math.ceil(cellValue.length * 1.2); maxTextLengths[colIndex] = Math.max(maxTextLengths[colIndex] || 0, estimatedWidth,); }

        if (colspan > 1 || rowspan > 1) {
          merges.push({ s: { r: rowIndex, c: colIndex }, e: { r: rowIndex + rowspan - 1, c: colIndex + colspan - 1 }, });

          for (let r = 0; r < rowspan; r++) { for (let c = 0; c < colspan; c++) { if (r !== 0 || c !== 0) { occupied[`${rowIndex + r},${colIndex + c}`] = true; } } }
        }

        colIndex += colspan;
        while (occupied[`${rowIndex},${colIndex}`]) { colIndex++; }
      }); rows.push(rowData);
    });

    const ws = XLSX.utils.aoa_to_sheet(rows); ws["!merges"] = merges; ws["!cols"] = maxTextLengths.map((wch) => ({ wch })); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, sheetName); XLSX.writeFile(wb, `${fileName}.xlsx`);
  } catch (error) { console.error("Error exporting to Excel:", error); }
}

export function exportToExcelhidelastcol(tableId, fileName) {
  const table = document.getElementById(tableId);
  if (!table) {
    console.error(`Table with ID ${tableId} not found!`);
    return;
  }

  try {
    const sheetName =
      fileName.length > 31 ? fileName.substring(0, 31) : fileName;

    const rows = Array.from(table.rows).map((row) => {
      return Array.from(row.cells)
        .slice(0, -1)
        .map((cell) => {
          const icon = cell.querySelector("img, svg, i");
          if (icon && icon.alt) {
            return icon.alt;
          }
          return cell.textContent.trim();
        });
    });

    const ws = XLSX.utils.aoa_to_sheet(rows);

    const range = XLSX.utils.decode_range(ws["!ref"]);
    ws["!ref"] = XLSX.utils.encode_range(range);

    const columnWidths = [];
    for (let col = 0; col <= range.e.c; col++) {
      const colLetter = XLSX.utils.encode_col(col);
      const cellWidth = Math.max(
        ...Object.keys(ws)
          .filter((cell) => cell.startsWith(colLetter))
          .map((cell) =>
            ws[cell] ? (ws[cell].v ? ws[cell].v.toString().length : 0) : 0,
          ),
      );
      columnWidths[col] = { wch: cellWidth + 2 };
    }
    ws["!cols"] = columnWidths;

    const headerRow = range.s.r;
    for (let col = 0; col <= range.e.c; col++) {
      const cell = ws[XLSX.utils.encode_cell({ r: headerRow, c: col })];
      if (cell) {
        cell.s = { alignment: { horizontal: "center" }, font: { bold: true } };
      }
    }
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
  }
}

export const handleKeyDown = (e) => {
  if (e.key === "Enter" || e.key === "Escape") {
    e.preventDefault();
    e.stopPropagation();
  }
};
export function generatePdfhidelastcol(tableid, filename) {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [900, 800],
  });

  autoTable(doc, {
    html: tableid,
    theme: "grid",
    tableWidth: 530,
    columnStyles: { 3: { cellWidth: "wrap" } },
    styles: { fontSize: 10 },
    headStyles: { halign: "center" },
    didParseCell: function (data) {
      const columnIndex = data.column.index;
      const lastColumnIndex = data.table.columns.length - 1;
      if (columnIndex === lastColumnIndex) {
        data.cell.raw = null;
        data.cell.text = "";
        data.row.cells[columnIndex] = null;
      }
    },
    didDrawCell: function (data) {
      const columnIndex = data.column.index;
      const lastColumnIndex = data.table.columns.length - 1;
      if (columnIndex === lastColumnIndex) {
        data.cell.text = "";
      }
    },
  });

  doc.save(`${filename}.pdf`);
}
export function isValidtwo(e) {
  const inputValue = e.target.value;
  if (
    (e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "-" &&
      e.key !== "." &&
      (isNaN(Number(e.key)) ||
        (inputValue.includes(".") && inputValue.split(".")[1].length >= 2))) ||
    (e.key === "." && inputValue.includes("."))
  ) {
    e.preventDefault();
  }
}

export function percentcal(e) {
  const inputValue = e.target.value;

  if (
    (e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "-" &&
      e.key !== "." &&
      (isNaN(Number(e.key)) ||
        (inputValue.includes(".") && inputValue.split(".")[1].length >= 2))) ||
    (e.key === "." && inputValue.includes("."))
  ) {
    e.preventDefault();
    return;
  }

  const { selectionStart, selectionEnd } = e.target;
  const newValue =
    inputValue.slice(0, selectionStart) +
    e.key +
    inputValue.slice(selectionEnd);

  const numericValue = Number(newValue);
  if (!isNaN(numericValue) && numericValue > 100) {
    e.preventDefault();
  }
}
export function isValidthreee(e) {
  const inputValue = e.target.value;
  if (
    (e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "-" &&
      e.key !== "." &&
      (isNaN(Number(e.key)) ||
        (inputValue.includes(".") && inputValue.split(".")[1].length >= 3))) ||
    (e.key === "." && inputValue.includes("."))
  ) {
    e.preventDefault();
  }
}

export const generatehodentryPdf = (tableId, formikValues, filename) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [3000, 3000],
  });

  autoTable(doc, {
    html: `#${tableId}`, theme: "grid", tableWidth: "wrap", columnStyles: { 3: { cellWidth: "wrap" } }, styles: { fontSize: 10 }, headStyles: { halign: "center" },
    didParseCell: function (data) {
      if (!data.cell.raw) return;
      if (data.cell.raw.querySelector("img")) { const img = data.cell.raw.querySelector("img"); data.cell.text = img.getAttribute("alt") || img.getAttribute("data-value") || "Image"; }
      const fieldInputs = data.cell.raw.querySelectorAll("input, select");
      if (fieldInputs.length > 0) { let cellValue = []; fieldInputs.forEach((field) => { const fieldName = field.getAttribute("name"); if (fieldName) { const formikValue = formikValues[fieldName] || field.value || ""; cellValue.push(formikValue); } }); data.cell.text = cellValue.join(" / "); }
    },
  }); doc.save(`${filename}.pdf`);
};

export const currentDate = new Date().toISOString().split("T")[0];

export const generateentryPdf = (tableId, formikValues, filename) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [900, 800],
  });

  autoTable(doc, {
    html: `#${tableId}`, theme: "grid", tableWidth: 530, columnStyles: { 3: { cellWidth: "wrap" } }, styles: { fontSize: 10 }, headStyles: { halign: "center" },
    didParseCell: function (data) { if (!data.cell.raw) return; if (data.cell.raw.querySelector("img")) { const img = data.cell.raw.querySelector("img"); data.cell.text = img.getAttribute("alt") || img.getAttribute("data-value") || "Image"; } const fieldInputs = data.cell.raw.querySelectorAll("input, select"); if (fieldInputs.length > 0) { let cellValue = []; fieldInputs.forEach((field) => { const fieldName = field.getAttribute("name"); if (fieldName) { const formikValue = formikValues[fieldName] || field.value || ""; cellValue.push(formikValue); } }); data.cell.text = cellValue.join(" / "); } },
  });
  doc.save(`${filename}.pdf`);
};

export const exportToentryExcel = (tableId, formikValues, fileName) => {
  const table = document.getElementById(tableId);
  if (!table) {
    console.error("Table not found!");
    return;
  }

  let data = [];
  let headers = [];
  let headerMatrix = [];
  let mergedHeaders = [];
  const merges = [];
  const maxTextLengths = [];
  const headerRows = table.querySelectorAll("thead tr");
  headerRows.forEach((row, rowIndex) => {
    let rowHeaders = [];
    let colIndex = 0;

    row.querySelectorAll("th").forEach((th) => {
      while (headerMatrix[rowIndex]?.[colIndex]) colIndex++;

      const colspan = parseInt(th.getAttribute("colspan") || "1", 10);
      const rowspan = parseInt(th.getAttribute("rowspan") || "1", 10);
      const text = th.innerText.trim();
      for (let i = 0; i < colspan; i++) {
        const len = text.length;
        maxTextLengths[colIndex + i] = Math.max(
          maxTextLengths[colIndex + i] || 0,
          len,
        );
      }

      rowHeaders[colIndex] = text;
      if (colspan > 1 || rowspan > 1) {
        merges.push({
          s: { r: rowIndex, c: colIndex },
          e: { r: rowIndex + rowspan - 1, c: colIndex + colspan - 1 },
        });
      }

      for (let r = 0; r < rowspan; r++) {
        if (!headerMatrix[rowIndex + r]) headerMatrix[rowIndex + r] = [];
        for (let c = 0; c < colspan; c++) {
          headerMatrix[rowIndex + r][colIndex + c] = text;
        }
      }

      colIndex += colspan;
    });

    headerMatrix[rowIndex] = rowHeaders;
  });

  headerMatrix.forEach((row, rowIndex) => {
    if (rowIndex === 0) {
      mergedHeaders.push(row);
    } else {
      const prev = mergedHeaders[mergedHeaders.length - 1];
      const newRow = row.map((val, idx) => (val === prev[idx] ? "" : val));
      mergedHeaders.push(newRow);
    }
  });

  headers = mergedHeaders;

  const rows = table.querySelectorAll("tbody tr");
  rows.forEach((row) => {
    const rowData = [];
    row.querySelectorAll("td").forEach((cell, index) => {
      const inputs = cell.querySelectorAll("input, select");
      let value = "";

      if (inputs.length > 0) {
        value = Array.from(inputs)
          .map((input) => {
            const name = input.getAttribute("name");
            return formikValues[name] || input.value || "";
          })
          .join(" / ");
      } else {
        value = cell.innerText.trim();
      }

      rowData.push(value);

      const len = value.length;
      maxTextLengths[index] = Math.max(maxTextLengths[index] || 0, len);
    });

    data.push(rowData);
  });

  const allData = [...headers, ...data];
  const worksheet = XLSX.utils.aoa_to_sheet(allData);

  worksheet["!merges"] = merges;

  worksheet["!cols"] = maxTextLengths.map((len) => ({ wch: len + 2 }));

  Object.keys(worksheet).forEach((key) => {
    if (key[0] === "!") return;

    const cell = worksheet[key];
    cell.s = {
      alignment: { vertical: "center", horizontal: "center", wrapText: true },
      font: { bold: headers.some((row) => row.includes(cell.v)) },
    };
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export const exportTokpientryExcel = (tableId, formikValues, fileName) => {
  const table = document.getElementById(tableId);
  if (!table) return;

  const merges = [];
  const styles = {};

  const buildMatrixFromTable = (table, formikValues) => {
    const rows = table.querySelectorAll("tr");
    const matrix = [];
    const skipMap = {};

    rows.forEach((row, rowIndex) => {
      let colIndex = 0;
      if (!matrix[rowIndex]) matrix[rowIndex] = [];
      row.querySelectorAll("th, td").forEach((cell) => {
        while (skipMap[`${rowIndex},${colIndex}`]) colIndex++;

        const rowspan = parseInt(cell.getAttribute("rowspan") || "1", 10);
        const colspan = parseInt(cell.getAttribute("colspan") || "1", 10);
        const isHeader = cell.tagName.toLowerCase() === "th";

        let value = "";
        const inputs = cell.querySelectorAll("input, select");

        if (inputs.length > 0) {
          value = Array.from(inputs)
            .map((input) => {
              const name = input.getAttribute("name");
              return formikValues[name] || input.value || "";
            })
            .join(" / ");
        } else {
          value = cell.innerText.trim();
        }

        matrix[rowIndex][colIndex] = value;

        if (isHeader) {
          styles[`${rowIndex},${colIndex}`] = {
            font: { bold: true },
            alignment: { horizontal: "center", vertical: "center" },
          };
        }

        if (value === "Not Yet Started") {
          styles[`${rowIndex},${colIndex}`] = {
            font: { bold: true },
            alignment: { horizontal: "center", vertical: "center" },
          };
        }

        if (rowspan > 1 || colspan > 1) {
          merges.push({
            s: { r: rowIndex, c: colIndex },
            e: { r: rowIndex + rowspan - 1, c: colIndex + colspan - 1 },
          });

          for (let r = 0; r < rowspan; r++) {
            for (let c = 0; c < colspan; c++) {
              if (r !== 0 || c !== 0) {
                skipMap[`${rowIndex + r},${colIndex + c}`] = true;
                if (!matrix[rowIndex + r]) matrix[rowIndex + r] = [];
                matrix[rowIndex + r][colIndex + c] = "";
              }
            }
          }
        }

        colIndex += colspan;
      });
    });

    return matrix;
  };

  const data = buildMatrixFromTable(table, formikValues);
  const worksheet = XLSX.utils.aoa_to_sheet(data);

  worksheet["!merges"] = merges;

  worksheet["!cols"] = Array(data[0]?.length || 10).fill({ wch: 25 });

  Object.entries(styles).forEach(([key, style]) => {
    const [r, c] = key.split(",").map(Number);
    const cellRef = XLSX.utils.encode_cell({ r, c });
    if (!worksheet[cellRef]) worksheet[cellRef] = { t: "s", v: "" };
    worksheet[cellRef].s = style;
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Entry Report");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
    cellStyles: true,
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `${fileName}.xlsx`);
};

export function gsdpReportexcel(tableId, fileName) {
  const table = document.getElementById(tableId);
  if (!table) {
    console.error(`Table with ID ${tableId} not found!`);
    return;
  }

  try {
    const sheetName =
      fileName.length > 31 ? fileName.substring(0, 31) : fileName;
    const rows = [];
    const rowSpans = new Map();
    const merges = [];
    let headerRowCount = 0;

    Array.from(table.rows).forEach((row, rowIndex) => {
      const rowData = [];
      let colIndex = 0;

      if (row.parentElement.tagName.toLowerCase() === "thead") {
        headerRowCount++;
      }

      Array.from(row.cells).forEach((cell) => {
        while (rowSpans.has(`${rowIndex}-${colIndex}`)) {
          rowData.push("");
          colIndex++;
        }

        const text = cell.textContent.trim();
        rowData.push(text);

        if (cell.rowSpan > 1) {
          for (let i = 1; i < cell.rowSpan; i++) {
            rowSpans.set(`${rowIndex + i}-${colIndex}`, text); // Store for future rows
          }
        }

        // Handle colSpan (Merge horizontally)
        if (cell.colSpan > 1) {
          merges.push({
            s: { r: rowIndex, c: colIndex },
            e: { r: rowIndex, c: colIndex + cell.colSpan - 1 },
          });

          for (let i = 1; i < cell.colSpan; i++) {
            rowData.push(""); // Fill merged columns with empty string
          }
        }

        colIndex++;
      });

      rows.push(rowData);
    });

    // Convert to Excel format
    const ws = XLSX.utils.aoa_to_sheet(rows);
    ws["!merges"] = merges; // Apply merged cell configurations

    // Auto-adjust column widths
    ws["!cols"] = rows[0].map((_, colIndex) => ({
      wch:
        Math.max(
          ...rows.map((row) => (row[colIndex] ? row[colIndex].length : 0)),
        ) + 2,
    }));

    // Style thead rows as bold
    for (let row = 0; row < headerRowCount; row++) {
      for (let col = 0; col < rows[row].length; col++) {
        const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
        if (ws[cellRef]) {
          ws[cellRef].s = {
            alignment: { horizontal: "center" },
            font: { bold: true },
          };
        }
      }
    }

    // Create workbook and export
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
  }
}

export function commonapisgsdp(
  formik,
  roleid,
  setDistrictList,
  setMandalList,
  district,
) {
  MasterService.getDistricts().then((res) => {
    if (res.data) {
      // setDistrictnamelist(res.data)
      let options = res.data.map((item, i) => {
        return (
          <option key={i} value={item.id}>
            {" "}
            {item.value}{" "}
          </option>
        );
      });
      setDistrictList(options);
    }
  });

  let params = { district_id: district };
  MasterService.getMandals(params).then((mandalRes) => {
    // setMandalnamelist(mandalRes.data)
    if (mandalRes) {
      let options = mandalRes.data.map((item, i) => (
        <option key={i} value={item.id}>
          {" "}
          {item.value}{" "}
        </option>
      ));
      setMandalList(options);
    }
  });
  if (roleid === "2") {
    formik.setFieldValue("district_id", district);
  }
}

export const startYear = 2022;
export const endYear = 2047;

export function generateYears() {
  const years = [];
  for (let year = startYear; year <= endYear; year++) {
    years.push(`${year}-${(year + 1).toString().slice(-2)}`);
  }
  return years;
}

export const startgrowthYear = 2023;
export const endgrowthYear = 2047;
export function generategrowthYears() {
  {
    const years = [];
    for (let year = startgrowthYear; year <= endgrowthYear; year++) {
      years.push(`${year}-${(year + 1).toString().slice(-2)}`);
    }
    return years;
  }
}

export function generateemployeemapPdf(tableid, filename) {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [900, 800],
  });

  autoTable(doc, {
    html: tableid,
    theme: "grid",
    tableWidth: 530,
    columnStyles: { 3: { cellWidth: "wrap" } },
    styles: { fontSize: 10 },
    headStyles: { halign: "center" },
    didParseCell: function (data) {
      if (data.cell.raw) {
        const totalColumns = data.table.columns.length;
        if (data.column.index === totalColumns - 1) {
          data.cell.text = "";
          data.cell.styles.cellPadding = 0;
          data.cell.styles.cellWidth = 0;
          data.cell.styles.minCellHeight = 0;
        }
        if (
          data.section === "head" &&
          data.cell.colSpan > 1 &&
          data.column.index === totalColumns - 1
        ) {
          data.cell.colSpan = 1;
        }
        const select = data.cell.raw.querySelector("select");
        if (select) {
          const selectedText =
            select.options[select.selectedIndex]?.text.trim();
          data.cell.text = selectedText === "--Select--" ? "" : selectedText;
        }
        const img = data.cell.raw.querySelector("img");
        if (img) {
          data.cell.text =
            img.getAttribute("alt") ||
            img.getAttribute("data-value") ||
            "Image";
        }
      }
    },
  });

  doc.save(`${filename}.pdf`);
}

export function exportToempmapExcel(tableId, fileName) {
  const table = document.getElementById(tableId);
  if (!table) {
    console.error(`Table with ID ${tableId} not found!`);
    return;
  }

  try {
    const sheetName =
      fileName.length > 31 ? fileName.substring(0, 31) : fileName;

    const rows = Array.from(table.rows).map((row) =>
      Array.from(row.cells)
        .slice(0, -1)
        .map((cell) => {
          const select = cell.querySelector("select");
          if (select) {
            const selectedText =
              select.options[select.selectedIndex]?.text.trim();
            return selectedText === "--Select--" ? "" : selectedText;
          }

          const icon = cell.querySelector("img, svg, i");
          if (icon && icon.alt) {
            return icon.alt;
          }

          return cell.textContent.trim();
        }),
    );

    const ws = XLSX.utils.aoa_to_sheet(rows); const range = XLSX.utils.decode_range(ws["!ref"]); const columnWidths = [];
    for (let col = 0; col <= range.e.c; col++) {
      const colLetter = XLSX.utils.encode_col(col);
      const cellWidth = Math.max(...Object.keys(ws).filter((cell) => cell.startsWith(colLetter)).map((cell) => ws[cell] ? (ws[cell].v ? ws[cell].v.toString().length : 0) : 0,),);
      columnWidths[col] = { wch: cellWidth + 2 };
    }
    ws["!cols"] = columnWidths;

    const headerRow = range.s.r;
    for (let col = 0; col <= range.e.c; col++) { const cell = ws[XLSX.utils.encode_cell({ r: headerRow, c: col })]; if (cell) { cell.s = { alignment: { horizontal: "center" }, font: { bold: true } }; } }
    const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, sheetName); XLSX.writeFile(wb, `${fileName}.xlsx`);
  } catch (error) { console.error("Error exporting to Excel:", error); }
}

export const datetime = (setcurrentdate, setcurrenttime) => {
  const currentDate = new Date().toLocaleDateString("en-GB");
  setcurrentdate(currentDate);
  const now = new Date();
  const options = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  };
  const formattedTime = now.toLocaleTimeString("en-IN", options);
  setcurrenttime(formattedTime.toUpperCase());
};

export function createSelectField(
  name,
  optionsList,
  value,
  setFieldValue,
  additionalOnChange = null,
  disabled = null,
  menuPortalTarget = null,
  styles = null,
) {
  return (
    <Select
      className="w-100"
      isClearable={true}
      isSearchable={true}
      name={name}
      required={true}
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.value}
      options={optionsList}
      value={optionsList?.find((option) => option.id === value) || ""}
      onChange={(option) => {
        setFieldValue(name, option ? option.id : "");
        if (additionalOnChange) additionalOnChange(option);
      }}
      isDisabled={disabled}
      {...(menuPortalTarget ? { menuPortalTarget } : {})}
      {...(styles ? { styles } : {})}
    />
  );
}
export function isValidIndianMobileNumber(mobile) {
  if (!mobile) {
    return true;
  }
  const mobileRegex = /^[6-9]\d{9}$/;
  return mobileRegex.test(mobile);
}

export const restrictToPasteOnlyMobileNumber = (formik, fieldName) => ({
  onPaste: (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").trim();
    const mobileRegex = /^[6-9]\d{9}$/;

    if (mobileRegex.test(pasted)) {
      formik.setFieldValue(fieldName, pasted);
    } else {
      formik.setFieldValue(fieldName, "");
    }
  },
});

export const restrictToPasteOnlyempid = (formik, fieldName) => ({
  onPaste: (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").trim();
    const mobileRegex = /^\d{1,8}$/;

    if (mobileRegex.test(pasted)) {
      formik.setFieldValue(fieldName, pasted);
    } else {
      formik.setFieldValue(fieldName, "");
    }
  },
});

export const restrictToPasteOnlyempname = (formik, fieldName) => ({
  onPaste: (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").trim();
    const nonDigitRegex = /^\D+$/;

    if (nonDigitRegex.test(pasted)) {
      formik.setFieldValue(fieldName, pasted);
    } else {
      formik.setFieldValue(fieldName, "");
    }
  },
});

export const restrictToPasteOnlyemail = (formik, fieldName) => ({
  onPaste: (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").trim();
    const emailRegex =
      /^[a-zA-Z0-9._%+-]{1,64}@[a-zA-Z0-9.-]{1,255}\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(pasted)) {
      formik.setFieldValue(fieldName, pasted);
    } else {
      formik.setFieldValue(fieldName, "");
    }
  },
});

export const getCurrentFinancialYear = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;

  if (month >= 4) {
    // From April to December
    return `${year}-${(year + 1).toString().slice(-2)}`;
  } else {
    // From January to March
    return `${year - 1}-${year.toString().slice(-2)}`;
  }
};

export const convertFormattedToPlainNumber = (formattedValue) => {
  if (!formattedValue) return "";

  const plain = formattedValue.toString().replace(/,/g, "");

  // Check if the result is a valid number (allowing negatives and decimals)
  const isValid = /^-?\d*(\.\d+)?$/.test(plain);

  return isValid ? plain : "";
};

// export const denomallowNumberswithMaxLengthtypeOnly = (e, maxLength, type, limit) => {
//   const input = e.target;
//   const value = input.value;
//   const key = e.key;
//   const fieldMaxlength = maxLength ?? 9;

//   const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'];
//   if (allowedKeys.includes(key)) {
//     return;
//   }

//   // Block any non-digit and non-dot keys
//   if (!/[\d.]/.test(key)) {
//     e.preventDefault();
//     return;
//   }

//   const { selectionStart, selectionEnd } = input;
//   const newValue = value.slice(0, selectionStart) + key + value.slice(selectionEnd);

//   if (type === "numeric") {
//     // Prevent '.' as the first character
//     if (key === '.' && (value === '' || selectionStart === 0)) {
//       e.preventDefault();
//       return;
//     }

//     // Allow only one '.' character
//     if (key === '.' && value.includes('.')) {
//       e.preventDefault();
//       return;
//     }

//     // Allow only up to `limit` decimal places
//     const numericRegex = new RegExp(`^\\d{0,${fieldMaxlength}}(\\.\\d{0,${limit}})?$`);
//     if (!numericRegex.test(newValue)) {
//       e.preventDefault();
//     }

//   } else if (type === "int") {
//     const intRegex = new RegExp(`^\\d{0,${fieldMaxlength}}$`);
//     if (!intRegex.test(newValue)) {
//       e.preventDefault();
//     }
//   }
// };

export const denomallowNumberswithMaxLengthtypeOnly = (
  e,
  maxLength,
  type,
  limit,
) => {
  let value = e.target.value;
  const fieldMaxlength = maxLength ?? 9;

  if (type === "numeric") {
    // Remove invalid characters except digit and dot
    value = value.replace(/[^0-9.]/g, "");

    // Allow only one dot
    value = value.replace(/(\..*)\./g, "$1");

    // Prevent dot as the first character
    if (value.startsWith(".")) {
      value = value.replace(".", ""); // remove starting dot
    }

    // Split decimal
    const parts = value.split(".");

    let intPart = parts[0] ?? "";
    let decPart = parts[1] ?? "";

    // Limit integer part length
    intPart = intPart.slice(0, fieldMaxlength);

    // Limit decimal part length
    if (parts.length > 1) {
      decPart = decPart.slice(0, limit);
      value = intPart + "." + decPart;
    } else {
      value = intPart;
    }
  }

  if (type === "int") {
    // Digits only
    value = value.replace(/[^0-9]/g, "");

    // Limit max length
    value = value.slice(0, fieldMaxlength);
  }

  // Set final value
  e.target.value = value;
};

// export const allowNumberswithMaxLengthtypeOnly = (e, maxLength, type, limit, isAllowedNegative) => {
//   const input = e.target;
//   const value = input.value;
//   const key = e.key;
//   const fieldMaxlength = maxLength ?? 9;
//   console.log("isAllowedNegative", isAllowedNegative);
//   const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'];
//   if (allowedKeys.includes(key)) return;

//   // Allow digits, dot, and minus if applicable
//   if (!/[\d.-]/.test(key)) {
//     e.preventDefault();
//     return;
//   }

//   const { selectionStart, selectionEnd } = input;
//   const newValue = value.slice(0, selectionStart) + key + value.slice(selectionEnd);

//   // Check for minus sign
//   if (key === '-') {
//     // Only allow minus if negative numbers are allowed, and only at the beginning
//     if (isAllowedNegative !== "-1" || selectionStart !== 0 || value.includes('-')) {
//       e.preventDefault();
//       return;
//     }
//     return; // Allow valid '-'
//   }

//   if (type === "numeric") {
//     // Prevent '.' as the first character or after '-'
//     if (key === '.' && (value === '' || selectionStart === 0 || (isAllowedNegative && selectionStart === 1 && value.startsWith('-')))) {
//       e.preventDefault();
//       return;
//     }

//     // Allow only one '.' character
//     if (key === '.' && value.includes('.')) {
//       e.preventDefault();
//       return;
//     }

//     const numericRegex = new RegExp(
//       `^-?\\d{0,${fieldMaxlength}}(\\.\\d{0,${limit}})?$`
//     );
//     if (!numericRegex.test(newValue)) {
//       e.preventDefault();
//     }

//   } else if (type === "int") {
//     const intRegex = new RegExp(`^-?\\d{0,${fieldMaxlength}}$`);
//     if (!intRegex.test(newValue)) {
//       e.preventDefault();
//     }
//   }
// };

export const allowNumberswithMaxLengthtypeOnly = (
  e,
  maxLength,
  type,
  limit,
  isAllowedNegative,
  // setFieldValue,
  // fieldName
) => {
  let value = e.target.value;
  const fieldMaxlength = maxLength ?? 9;

  value = value.replace(/,/g, "");
  if (isAllowedNegative !== "-1") { value = value.replace(/-/g, ""); } else { value = value.replace(/(?!^)-/g, "").replace(/--+/g, "-"); }

  if (type === "numeric") {
    value = value.replace(/[^0-9.-]/g, ""); value = value.replace(/(?!^)-/g, ""); value = value.replace(/(\..*)\./g, "");
    if (value.startsWith(".")) { value = value.replace(".", ""); }

    let [intPart, decPart = ""] = value.split("."); intPart = intPart.replace("-", "").slice(0, fieldMaxlength); decPart = decPart.slice(0, limit); value = (value.startsWith("-") ? "-" : "") + intPart + (value.includes(".") ? "." + decPart : "");
  }

  if (type === "int") {
    value = value.replace(/[^0-9-]/g, "");

    if (value.startsWith("-")) { value = "-" + value.slice(1).replace(/[^0-9]/g, "").slice(0, fieldMaxlength); } else { value = value.replace(/[^0-9]/g, "").slice(0, fieldMaxlength); }
  }

  // UI update
  e.target.value = value;

  // Formik update
  // setFieldValue(fieldName, value);
};

// export const allowNumberswithMaxLengthcatidtypeOnly = (e, maxLength, type, limit, isAllowedNegative) => {
//   const input = e.target;
//   const value = input.value;
//   const key = e.key;

//   const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
//   if (allowedKeys.includes(key)) return;

//   // Allow digits, dot, and minus if applicable
//   if (!/[\d.-]/.test(key)) {
//     e.preventDefault();
//     return;
//   }

//   const { selectionStart, selectionEnd } = input;
//   const newValue = value.slice(0, selectionStart) + key + value.slice(selectionEnd);
//   const cleanNewValue = newValue.replace(/,/g, "");

//   // Handle negative sign
//   if (key === '-') {
//     if (isAllowedNegative !== "-1" || selectionStart !== 0 || value.includes('-')) {
//       e.preventDefault();
//       return;
//     }
//     return; // allow valid '-'
//   }

//   if (type === "numeric") {
//     // Prevent '.' at beginning or right after '-'
//     if (key === '.' && (value === '' || selectionStart === 0 || (isAllowedNegative && value.startsWith('-') && selectionStart === 1))) {
//       e.preventDefault();
//       return;
//     }

//     // Allow only one '.' character
//     if (key === '.' && value.includes('.')) {
//       e.preventDefault();
//       return;
//     }

//     // Regex for numeric with optional negative and decimal limit
//     const numericRegex = new RegExp(`^-?\\d{0,${maxLength}}(\\.\\d{0,${limit}})?$`);
//     if (!numericRegex.test(cleanNewValue)) {
//       e.preventDefault();
//     }

//   } else if (type === "int") {
//     const intRegex = new RegExp(`^-?\\d{0,${maxLength}}$`);
//     if (!intRegex.test(cleanNewValue)) {
//       e.preventDefault();
//     }
//   }
// };

export const allowNumberswithMaxLengthcatidtypeOnly = (
  e,
  maxLength,
  type,
  limit,
  isAllowedNegative,
) => {
  let value = e.target.value;

  // Remove commas
  value = value.replace(/,/g, "");

  // Negative handling
  if (isAllowedNegative !== "-1") {
    value = value.replace(/-/g, "");
  } else {
    value = value.replace(/(?!^)-/g, "").replace(/--+/g, "-");
  }

  if (type === "numeric") {
    value = value.replace(/[^0-9.-]/g, "");
    value = value.replace(/(?!^)-/g, "");
    value = value.replace(/(\..*)\./g, "");

    if (value.startsWith(".")) {
      value = value.replace(".", "");
    }
    let [intPart, decPart = ""] = value.split(".");
    intPart = intPart.replace("-", "").slice(0, maxLength);
    decPart = decPart.slice(0, limit);

    value =
      (value.startsWith("-") ? "-" : "") +
      intPart +
      (value.includes(".") ? "." + decPart : "");
  }

  if (type === "int") {
    value = value.replace(/[^0-9-]/g, "");

    if (value.startsWith("-")) {
      value =
        "-" +
        value
          .slice(1)
          .replace(/[^0-9]/g, "")
          .slice(0, maxLength);
    } else {
      value = value.replace(/[^0-9]/g, "").slice(0, maxLength);
    }
  }

  e.target.value = value;
};

// export const formatNumberIndianWithDecimal = (value) => {
//   if (!value) return "";

//   const numStr = value.toString().replace(/,/g, "");
//   if (isNaN(numStr)) return value;

//   const isNegative = numStr.startsWith("-");
//   const absoluteStr = isNegative ? numStr.slice(1) : numStr;

//   const [integerPart, decimalPart] = absoluteStr.split(".");

//   const n = integerPart.length;

//   let formattedInt;
//   if (n <= 3) {
//     formattedInt = integerPart;
//   } else {
//     let result = integerPart.slice(n - 3);
//     let start = n - 3;

//     while (start > 0) {
//       const end = start;
//       start = Math.max(0, start - 2);
//       result = integerPart.slice(start, end) + "," + result;
//     }
//     formattedInt = result;
//   }

//   const formatted = decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
//   return isNegative ? `-${formatted}` : formatted;
// };

export const formatNumberIndianWithDecimal = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const numStr = value.toString().replace(/,/g, "");
  if (isNaN(numStr)) return value;

  const isNegative = numStr.startsWith("-");
  const absoluteStr = isNegative ? numStr.slice(1) : numStr;

  const [integerPart, decimalPart] = absoluteStr.split(".");
  const n = integerPart.length;

  let formattedInt;
  if (n <= 3) {
    formattedInt = integerPart;
  } else {
    let result = integerPart.slice(n - 3);
    let start = n - 3;

    while (start > 0) {
      const end = start;
      start = Math.max(0, start - 2);
      result = integerPart.slice(start, end) + "," + result;
    }
    formattedInt = result;
  }

  const formatted =
    decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;

  return isNegative ? `-${formatted}` : formatted;
};

export function commonSelectProps({
  name,
  options,
  value,
  optionValueKey = "dept_id",
  optionLabelKey = "dept_name",
  isDisabled = false,
  formik,
  extraOnChange = () => { },
}) {
  return {
    className: "w-100",
    isClearable: true,
    isSearchable: true,
    name: name,
    options: options,
    menuPortalTarget: document.body,
    styles: {
      menuPortal: (base) => ({ ...base, zIndex: 1000 }),

      singleValue: (base) => ({
        ...base,
        fontWeight: "bold",
      }),

      input: (base) => ({
        ...base,
        fontWeight: "bold",
      }),
    },

    getOptionValue: (option) => option[optionValueKey],
    getOptionLabel: (option) => option[optionLabelKey],

    value: options?.find((option) => option[optionValueKey] === value) || "",

    isDisabled: isDisabled,

    onChange: (option) => {
      const selectedValue = option ? option[optionValueKey] : "";
      formik.setFieldValue(name, selectedValue);

      // Call extra function if needed
      extraOnChange(option);

      // Common functions if you need
      // emptyData ? etc.
    },
  };
}

export function exporKPIExcel(tableId, fileName) {
  const table = document.getElementById(tableId); if (!table) { console.error(`Table with ID ${tableId} not found!`); return; }

  try {
    const sheetName =
      fileName.length > 31 ? fileName.substring(0, 31) : fileName;
    const rows = []; const merges = []; const occupied = {}; const maxTextLengths = []; const tableRows = Array.from(table.rows);
    tableRows.forEach((row, rowIndex) => {
      const rowData = []; let colIndex = 0;
      while (occupied[`${rowIndex},${colIndex}`]) { colIndex++; }

      Array.from(row.cells).forEach((cell) => {
        const colspan = parseInt(cell.getAttribute("colspan")) || 1; const rowspan = parseInt(cell.getAttribute("rowspan")) || 1; let cellValue = cell.textContent.trim(); const img = cell.querySelector("img");
        if (img) { cellValue = img.getAttribute("alt")?.trim() || img.getAttribute("data-value")?.trim() || "Yes"; }

        const isHeader = row.parentElement.tagName === "THEAD"; let horizontalAlign = isHeader ? "center" : "left";
        if (row.textContent.includes("Report On")) { horizontalAlign = "right"; }
        const alignment = { horizontal: horizontalAlign, vertical: "center", wrapText: true, }; const cellStyle = { alignment, font: { bold: isHeader, color: { rgb: "000000" } }, };
        rowData[colIndex] = { v: cellValue, s: cellStyle };
        if (colspan === 1) { const estimatedWidth = cellValue.length <= 4 ? cellValue.length + 4 : Math.ceil(cellValue.length * 1.2); maxTextLengths[colIndex] = Math.max(maxTextLengths[colIndex] || 0, estimatedWidth,); }

        if (colspan > 1 || rowspan > 1) { merges.push({ s: { r: rowIndex, c: colIndex }, e: { r: rowIndex + rowspan - 1, c: colIndex + colspan - 1 }, }); for (let r = 0; r < rowspan; r++) { for (let c = 0; c < colspan; c++) { if (r !== 0 || c !== 0) { occupied[`${rowIndex + r},${colIndex + c}`] = true; } } } }

        colIndex += colspan; while (occupied[`${rowIndex},${colIndex}`]) { colIndex++; }
      }); rows.push(rowData);
    });
    const ws = XLSX.utils.aoa_to_sheet(rows); ws["!merges"] = merges; ws["!cols"] = maxTextLengths.map((wch) => ({ wch })); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, sheetName); XLSX.writeFile(wb, `${fileName}.xlsx`);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
  }
}

export function generateindPdf(tableid, filename, columnsCount) {
  const exportHeaders = document.querySelectorAll(".only-export");
  exportHeaders.forEach((el) => {
    el.style.display = "table-row";
  });

  // ✅ Hide sort arrows temporarily
  const sortButtons = document.querySelectorAll(`#${tableid} thead button`);
  const arrowSymbols = [];
  sortButtons.forEach((btn, i) => {
    arrowSymbols[i] = btn.innerHTML; // store arrows
    btn.innerHTML = ""; // remove arrows
  });

  let format = "a4";
  if (columnsCount > 15) {
    format = "a0";
  } else if (columnsCount > 10) {
    format = "a2";
  } else {
    format = "a3";
  }

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: format,
  });

  // ✅ Make sure we prepend '#' here
  autoTable(doc, {
    html: `#${tableid}`,
    theme: "grid",
    styles: { fontSize: 9 },
    headStyles: { halign: "center" },
    columnStyles: { 0: { cellWidth: "wrap" } },
    didParseCell: function (data) {
      const rawText = data.cell.text?.join(" ")?.trim();
      if (rawText?.startsWith("Report On")) {
        data.cell.styles.halign = "right";
      }
      if (data.cell.raw && data.cell.raw.querySelector("img")) {
        const img = data.cell.raw.querySelector("img");
        data.cell.text =
          img.getAttribute("alt") || img.getAttribute("data-value") || "Image";
      }
    },
  });
  doc.save(`${filename}.pdf`);

  // ✅ Restore arrows back to UI
  sortButtons.forEach((btn, i) => {
    btn.innerHTML = arrowSymbols[i];
  });

  exportHeaders.forEach((el) => {
    el.style.display = "none";
  });
}

export const getReadableTimeStamp = () => {
  const now = new Date();

  const day = String(now.getDate()).padStart(2, "0");
  const month = now.toLocaleString("en-US", { month: "short" });
  const year = now.getFullYear();

  let hours = now.getHours();
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12;
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year}_${hours}-${minutes}-${ampm}`;
};

export async function generatedashPdf(
  tableid,
  filename,
  columnsCount,
  chartid,
  titleText,
) {
  let format = "a4"; // default
  if (columnsCount > 15) {
    format = "a0";
  } else if (columnsCount > 10) {
    format = "a2";
  } else {
    format = "a3";
  }

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: format,
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // ✅ Title at top center
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(titleText, pageWidth / 2, 15, { align: "center" });

  // ✅ Clone table
  const originalTable = document.getElementById(tableid);
  const clonedTable = originalTable.cloneNode(true);

  // Show only-export rows
  clonedTable.querySelectorAll(".only-export").forEach((el) => {
    el.style.display = "table-row";
  });

  // Remove sort buttons
  clonedTable.querySelectorAll("thead button").forEach((btn) => btn.remove());

  // ✅ Chart export
  const chartElement = document.getElementById(chartid);
  if (chartElement) {
    try {
      const imgData = await domtoimage.toPng(chartElement, {
        quality: 1,
        bgcolor: "#ffffff",
      });

      if (imgData.startsWith("data:image")) {
        const imgProps = doc.getImageProperties(imgData);

        // Half page width
        const chartWidth = pageWidth / 2 - 20;
        let chartHeight = (imgProps.height * chartWidth) / imgProps.width;

        // Cap chart height so it doesn’t exceed page
        if (chartHeight > pageHeight - 40) {
          chartHeight = pageHeight - 40;
        }

        const startY = 25; // same Y for chart + table

        // Draw chart (left half)
        doc.addImage(imgData, "PNG", 10, startY, chartWidth, chartHeight);

        // Draw table (right half)
        autoTable(doc, {
          html: clonedTable,
          theme: "grid",
          styles: { fontSize: 8 },
          headStyles: { halign: "center" },
          columnStyles: { 0: { cellWidth: "wrap" } },
          startY: startY,
          margin: { left: pageWidth / 2 },
          tableWidth: pageWidth / 2 - 20,
          pageBreak: "avoid", // keep table on same page
        });
      }
    } catch (err) {
      console.error("dom-to-image failed:", err);
    }
  }

  // ✅ Save PDF
  doc.save(`${filename}_${getReadableTimeStamp()}.pdf`);
}

export function exportTodashExcel(tableId, fileName) {
  const table = document.getElementById(tableId);
  if (!table) {
    console.error(`Table with ID ${tableId} not found!`);
    return;
  }

  try {
    const sortButtons = table.querySelectorAll("thead button");
    const arrowSymbols = [];
    sortButtons.forEach((btn, i) => {
      arrowSymbols[i] = btn.innerHTML;
      btn.innerHTML = "";
    });

    // ✅ Timestamp
    const timeStamp = getReadableTimeStamp();

    // Sheet name max 31 chars (Excel limit)
    const sheetNameBase = `${fileName}_${timeStamp}`;
    const sheetName =
      sheetNameBase.length > 31
        ? sheetNameBase.substring(0, 31)
        : sheetNameBase;

    const rows = [];
    const merges = [];
    const occupied = {};
    const maxTextLengths = [];

    const tableRows = Array.from(table.rows);

    tableRows.forEach((row, rowIndex) => {
      const rowData = [];
      let colIndex = 0;
      while (occupied[`${rowIndex},${colIndex}`]) colIndex++;

      Array.from(row.cells).forEach((cell) => {
        const colspan = parseInt(cell.getAttribute("colspan")) || 1;
        const rowspan = parseInt(cell.getAttribute("rowspan")) || 1;
        // const cellValue = cell.textContent.trim();
        const isHeader = row.parentElement.tagName === "THEAD";

        // Detect numeric values
        let cellValue = cell.textContent.trim();
        const numericValue = Number(cellValue.replace(/,/g, ""));
        const isNumber = !isNaN(numericValue) && cellValue !== "";

        let horizontalAlign = isHeader ? "center" : "left";
        if (row.textContent.includes("Report On")) {
          horizontalAlign = "right";
        }

        const alignment = {
          horizontal: horizontalAlign,
          vertical: "center",
          wrapText: true,
        };
        const cellStyle = {
          alignment,
          font: { bold: isHeader, color: { rgb: "000000" } },
        };

        // rowData[colIndex] = { v: cellValue, s: cellStyle };
        rowData[colIndex] = {
          v: isNumber ? numericValue : cellValue,
          t: isNumber ? "n" : "s",
          s: cellStyle,
        };

        if (colspan === 1) {
          const estimatedWidth =
            cellValue.length <= 4
              ? cellValue.length + 4
              : Math.ceil(cellValue.length * 1.2);
          maxTextLengths[colIndex] = Math.max(
            maxTextLengths[colIndex] || 0,
            estimatedWidth,
          );
        }

        if (colspan > 1 || rowspan > 1) {
          merges.push({
            s: { r: rowIndex, c: colIndex },
            e: { r: rowIndex + rowspan - 1, c: colIndex + colspan - 1 },
          });
          for (let r = 0; r < rowspan; r++) {
            for (let c = 0; c < colspan; c++) {
              if (r !== 0 || c !== 0) {
                occupied[`${rowIndex + r},${colIndex + c}`] = true;
              }
            }
          }
        }
        colIndex += colspan;
        while (occupied[`${rowIndex},${colIndex}`]) colIndex++;
      });

      rows.push(rowData);
    });

    const ws = XLSX.utils.aoa_to_sheet(rows);
    ws["!merges"] = merges;
    ws["!cols"] = maxTextLengths.map((wch) => ({ wch }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    // ✅ Final Excel filename with timestamp
    XLSX.writeFile(wb, `${fileName}_${timeStamp}.xlsx`);

    // Restore sort icons
    sortButtons.forEach((btn, i) => {
      btn.innerHTML = arrowSymbols[i];
    });
  } catch (error) {
    console.error("Error exporting to Excel:", error);
  }
}
export const isFY2025OrLater = (fy) => {
  const startYear = parseInt(fy.split("-")[0], 10);
  return startYear >= 2025;
};

export function allowOnlyNumbersandDecimal(e) {
  const char = e.key;
  if (!/[0-9.]/.test(char)) {
    e.preventDefault();
  }
  if (char === "." && e.target.value.includes(".")) {
    e.preventDefault();
  }
}

export function multiGeneratePdf(containerId, filename, columnsCount) {
  const exportHeaders = document.querySelectorAll(".only-export");
  exportHeaders.forEach((el) => (el.style.display = "table-row"));

  let format = "a4";
  if (columnsCount > 15) format = "a0";
  else if (columnsCount > 10) format = "a2";
  else format = "a3";

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: format,
  });

  const container = document.getElementById(containerId);
  if (!container) {
    console.error("Container not found");
    return;
  }

  const tables = container.querySelectorAll("table");

  tables.forEach((table, index) => {
    autoTable(doc, {
      html: table,
      theme: "grid",
      styles: { fontSize: 9 },
      headStyles: { halign: "center" },
    });

    // Add space between tables
    if (index < tables.length - 1) {
      doc.addPage();
    }
  });

  doc.save(`${filename}.pdf`);

  exportHeaders.forEach((el) => (el.style.display = "none"));
}

export function mutliExportToExcel(containerId, fileName) {
  const container = document.getElementById(containerId);

  if (!container) {
    console.error(`Container ${containerId} not found!`);
    return;
  }

  const tables = container.querySelectorAll("table");

  if (tables.length === 0) {
    console.error("No tables found inside container!");
    return;
  }

  const wb = XLSX.utils.book_new();

  tables.forEach((table, index) => {
    const sheetName =
      tables.length > 1 ? `Table_${index + 1}` : fileName.substring(0, 31);

    const ws = XLSX.utils.table_to_sheet(table);
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
  });

  XLSX.writeFile(wb, `${fileName}.xlsx`);
}

export const maskMobile = (phone) => {
  if (!phone) return "";
  const visible = phone.slice(-4);
  const masked = phone.slice(0, -4).replace(/./g, "*");

  return masked + visible;
};

export const maskEmail = (email) => {
  if (!email) return "";

  const [name, domain] = email.split("@");

  if (name.length <= 4) {
    return `${"*".repeat(name.length)}@${domain}`;
  }

  const visiblePart = name.slice(-4);
  const maskedPart = "*".repeat(name.length - 4);

  return `${maskedPart}${visiblePart}@${domain}`;
};

export const userid = localStorage.getItem("username");

// export const downloadpdf = async (item) => {
//     try {
//       const params = {
//         mode: "dashboarddatadownload",
//         userId: userid,
//         districtId: item.district_id,
//         deptId: item.dept_id,
//         cfmsId: item.cfms_id,
//         mobile: item.mobile,
//         nameOfTopic: item.name_of_topic,
//       };

//       store.dispatch({ type: "SHOW_SPINNER" });

//       const res = await KpiService.snccsFeedbackFormDashboard(params);

//       if (
//         res?.data?.SCODE === "01" &&
//         Array.isArray(res.data.SDESC) &&
//         res.data.SDESC.length > 0
//       ) {

//         const dataa = res.data.SDESC[0];

//         const documentData = {
//           cfmsId: dataa?.cfms_id || "",
//           fname: dataa?.f_name || "",
//           designation: dataa?.designation || "",
//           batchYear: dataa?.batch_year || "",
//           currentServiceStatus:
//             dataa?.current_service_status || "",
//           trainingInstitute:
//             dataa?.training_institute || "",
//           currentPosting:
//             dataa?.current_posting || "",
//           nameOfTopic:
//             // dataa?.name_of_topic ||
//             dataa?.topic_des ||
//             "",
//           pgapsAndChallenges:
//             dataa?.p_gaps_and_challenges || "",
//           potentialSol:
//             dataa?.potential_sol || "",
//           bestPractices:
//             dataa?.best_practices || "",
//         };

//         console.log(
//           "Generating PDF:",
//           documentData
//         );

//         await generatePdfDocument(documentData);
//       } else {
//         console.log("No data found");
//       }
//     } catch (error) {
//       console.error(
//         "Error generating PDF:",
//         error
//       );
//     } finally {
//       store.dispatch({ type: "HIDE_SPINNER" });
//     }
//   };

//  export const generatePdfDocument = async (data) => {

//     let container = null;

//     try {

//       console.log("PDF DATA:", data);

//       const { cfmsId, fname, designation, batchYear, currentServiceStatus, trainingInstitute, currentPosting, nameOfTopic, subTopicNames, pgapsAndChallenges, potentialSol, bestPractices, } = data || {};

//       // =========================================================
//       // HELPERS
//       // =========================================================

//       const safeText = (value) => { if (value === null || value === undefined) { return ""; } return String(value); };

//       const escapeHtml = (value) => { return safeText(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;"); };

//       const safeCfmsId = safeText(cfmsId).replace(/[^a-zA-Z0-9_-]/g, "").trim();

//       // =========================================================
//       // RICH TEXT SANITIZATION
//       // =========================================================

//       const sanitizeRichText = (value) => {
//         if (!value) { return ""; }

//         try {

//           const parser = new DOMParser(); const doc = parser.parseFromString(`<div>${safeText(value)}</div>`, "text/html"); const root = doc.body.firstElementChild;

//           if (!root) { return escapeHtml(value).replace(/\n/g, "<br>"); }

//           root.querySelectorAll("script, style, iframe, object, embed, link, meta, noscript").forEach((el) => el.remove());

//           const allowedTags = new Set(["P", "BR", "STRONG", "B", "EM", "I", "U", "UL", "OL", "LI", "TABLE", "THEAD", "TBODY", "TFOOT", "TR", "TH", "TD", "DIV", "SPAN", "IMG",]);

//           const cleanNode = (node) => {

//             if (node.nodeType === Node.TEXT_NODE) { return escapeHtml(node.textContent); }
//             if (node.nodeType !== Node.ELEMENT_NODE) { return ""; }

//             const tag = node.tagName.toUpperCase();

//             if (!allowedTags.has(tag)) { return Array.from(node.childNodes).map(cleanNode).join(""); }

//             if (tag === "IMG") {
//               const src = node.getAttribute("src");
//               if (!src || !src.startsWith("data:image/")) { return ""; }

//               return `
//       <img
//         src="${src}"
//         style="
//           width: 180px;
//           max-width: 180px;
//           height: auto;
//           display: block;
//           margin: 6pt 0;
//         "
//         alt=""
//       />
//     `;
//             }

//             if (tag === "BR") { return "<br>"; }

//             if (tag === "TABLE") {
//               return `
//                   <table>
//                     ${Array.from(node.childNodes)
//                   .map(cleanNode)
//                   .join("")}
//                   </table>
//                 `;
//             }

//             if (tag === "TH" || tag === "TD") { return ` <${tag.toLowerCase()}> ${Array.from(node.childNodes).map(cleanNode).join("")} </${tag.toLowerCase()}> `; }

//             return ` <${tag.toLowerCase()}> ${Array.from(node.childNodes).map(cleanNode).join("")} </${tag.toLowerCase()}> `;
//           };

//           return Array.from(root.childNodes).map(cleanNode).join("").trim();

//         } catch (error) {
//           console.error("Rich text sanitization error:", error);

//           return escapeHtml(value).replace(/\n/g, "<br>");
//         }
//       };

//       const getSubTopicsHtml = () => {
//         if (!Array.isArray(subTopicNames) || subTopicNames.length === 0) { return ""; }

//         return `
//             <div class="sub-topic-section">

//               <div class="sub-topic-label">
//                 Specific Priority Area(s) :
//               </div>

//               <ul class="sub-topic-list">

//                 ${subTopicNames.map((subTopic) => ` <li> ${escapeHtml(subTopic)} </li> `).join("")}

//               </ul>

//             </div>
//           `;
//       };

//       const getRichContent = (value) => {
//         const result = sanitizeRichText(value); if (!result) {

//           return `
//               <p class="empty-content">
//                 Not provided
//               </p>
//             `;
//         }
//         return result;
//       };

//       const getImageAsBase64 = async (imageUrl) => {
//         try {
//           const response = await fetch(imageUrl);

//           if (!response.ok) { throw new Error(`Failed to load image: ${response.status}`); }

//           const blob = await response.blob();

//           return await new Promise((resolve, reject) => { const reader = new FileReader(); reader.onloadend = () => { resolve(reader.result); }; reader.onerror = reject; reader.readAsDataURL(blob); });

//         } catch (error) { console.error("Logo loading failed:", error); return ""; }
//       };

//       const logoBase64 = await getImageAsBase64(`${window.location.origin}/images/nitiaayog.png`);

//       const status = safeText(currentServiceStatus).trim();

//       const isProbationer = status.toLowerCase() === "probationer" || status === "1";

//       const postingLabel = isProbationer ? "Training Institute / Academy" : "Current Posting";
//       const postingValue = isProbationer ? trainingInstitute : currentPosting;

//       // =========================================================
//       // PDF HTML
//       // =========================================================

//       const html = `

//           <style>

//             * {
//               box-sizing: border-box;
//             }

//             html,
//             body {
//               margin: 0;
//               padding: 0;
//               background: #ffffff;
//             }

//             .pdf-document {

//               width: 794px;

//               min-height: 1123px;

//               padding: 15mm;

//               margin: 0;

//               background: #ffffff;

//               color: #111111;

//               font-family:
//                 "Times New Roman",
//                 Times,
//                 serif;

//               font-size: 11pt;

//               line-height: 1.25;
//             }

//             /* =====================================================
//                HEADER
//                ===================================================== */

//             .pdf-header {

//               text-align: center;

//               margin-bottom: 32px;

//               padding-top: 4px;
//             }

//             .logo-wrapper {

//               text-align: center;

//               height: 100px;

//               margin-bottom: 18px;

//               display: flex;

//               justify-content: center;

//               align-items: center;
//             }

//             .logo {

//               width: 82px;

//               height: 72px;

//               object-fit: contain;

//               display: block;
//             }

//             .main-title,
//             .sub-title {

//               font-family:
//                 "Times New Roman",
//                 Times,
//                 serif;

//               font-size: 14pt;

//               font-weight: 700;

//               line-height: 1.25;

//               text-align: center;

//               display: block;

//               color: #000000;
//             }

//             .main-title {

//               margin: 0;

//               padding: 0;

//               color: #000000;
//             }

//             .sub-title {

//               margin-top: 6pt;
//             }

//             /* =====================================================
//                SECTION HEADINGS
//                ===================================================== */

//             .section-title {

//               font-family:
//                 "Times New Roman",
//                 Times,
//                 serif;

//               font-size: 12pt;

//               font-weight: 700;

//               margin-top: 14pt;

//               margin-bottom: 6pt;

//               line-height: 1.25;
//             }

//             /* =====================================================
//                OFFICER DETAILS
//                ===================================================== */

//             .officer-details {

//               margin: 0;

//               padding-left: 28px;

//               font-family:
//                 "Times New Roman",
//                 Times,
//                 serif;

//               font-size: 11pt;

//               line-height: 1.25;
//             }

//             .officer-details li {

//               margin-bottom: 3pt;

//               padding-left: 1px;
//             }

//             .officer-details strong {

//               font-weight: 700;
//             }

//             /* =====================================================
//                FEEDBACK SECTION
//                ===================================================== */

//             .feedback-section {

//               margin-top: 9pt;

//               margin-bottom: 0;

//               padding-bottom: 0;
//             }

//             .question-title {

//               font-family:
//                 "Times New Roman",
//                 Times,
//                 serif;

//               font-size: 12pt;

//               font-weight: 700;

//               line-height: 1.25;

//               margin-top: 10pt;

//               margin-bottom: 8pt;

//               padding: 0;
//             }

//             .question-note {

//               font-size: 11pt;

//               font-style: italic;

//               color: #666666;

//               line-height: 1.25;

//               margin-top: 0;

//               margin-bottom: 6pt;
//             }

//             /* =====================================================
//                RICH CONTENT
//                ===================================================== */

//             .rich-content {

//               font-family:
//                 "Times New Roman",
//                 Times,
//                 serif;

//               font-size: 11pt;

//               line-height: 1.25;

//               color: #222222;

//               word-wrap: break-word;

//               overflow-wrap: break-word;

//               margin-left: 30px;

//               margin-top: 0;

//               padding: 0;
//             }

//             .rich-content p {

//               margin-top: 0;

//               margin-bottom: 6pt;

//               padding: 0;
//             }

//             /* =====================================================
//                BASE64 IMAGES
//                ===================================================== */

//          .rich-content img {
//       width: 180px;
//       max-width: 180px;
//       height: auto;
//       display: block;
//       margin: 6pt 0;
//     }

//             /* =====================================================
//                BULLET / NUMBERED LISTS
//                ===================================================== */

//             .rich-content ul {

//               margin-top: 3px;

//               margin-bottom: 6pt;

//               padding-left: 40px;
//             }

//             .rich-content ol {

//               margin-top: 3px;

//               margin-bottom: 6pt;

//               padding-left: 40px;
//             }

//             .rich-content li {

//               margin-bottom: 3px;

//               padding-left: 3px;
//             }

//             .rich-content li ul,
//             .rich-content li ol {

//               padding-left: 30px;
//             }

//             /* =====================================================
//                TABLES
//                ===================================================== */

//             .rich-content table {

//               width: 100%;

//               border-collapse: collapse;

//               margin-top: 8px;

//               margin-bottom: 10px;
//             }

//             .rich-content th,
//             .rich-content td {

//               border: 1px solid #999999;

//               padding: 5px 7px;

//               vertical-align: top;

//               font-size: 10.5pt;

//               line-height: 1.25;
//             }

//             .rich-content th {

//               font-weight: 700;

//               background: #f3f3f3;
//             }

//             .empty-content {

//               color: #777777;

//               font-style: italic;

//               margin: 0;
//             }

//             /* =====================================================
//                SUB TOPICS
//                ===================================================== */

//             .sub-topic-section {

//               margin-left: 30px;

//               margin-top: 4pt;

//               margin-bottom: 8pt;

//               font-family:
//                 "Times New Roman",
//                 Times,
//                 serif;

//               font-size: 11pt;

//               line-height: 1.25;
//             }

//             .sub-topic-label {

//               font-weight: 700;

//               margin-bottom: 3pt;
//             }

//             .sub-topic-list {

//               margin-top: 2pt;

//               margin-bottom: 0;

//               padding-left: 28px;
//             }

//             .sub-topic-list li {

//               margin-bottom: 3pt;

//               padding-left: 3px;

//               line-height: 1.25;
//             }

//           </style>

//           <div class="pdf-document">

//             <!-- HEADER -->

//             <div class="pdf-header">

//               ${logoBase64
//           ? `
//                     <div class="logo-wrapper">

//                       <img
//                         class="logo"
//                         src="${logoBase64}"
//                         alt="NITI Aayog"
//                       />

//                     </div>
//                   `
//           : ""
//         }

//               <div class="main-title">
//                 Sixth National Conference of Chief Secretaries
//               </div>

//               <div class="sub-title">
//                 Feedback Note
//               </div>

//             </div>

//             <!-- SECTION 1 -->

//             <div class="section-title">
//               Section 1: Officer Name and Details
//             </div>

//             <ul class="officer-details">

//               <li>
//                 <strong>Name:</strong>
//                 ${escapeHtml(fname)}
//               </li>

//               <li>
//                 <strong>Designation:</strong>
//                 ${escapeHtml(designation)}
//               </li>

//               <li>
//                 <strong>Batch:</strong>
//                 ${escapeHtml(batchYear)}
//               </li>

//               <li>
//                 <strong>Current Service Status:</strong>
//                 ${escapeHtml(currentServiceStatus)}
//               </li>

//               <li>
//                 <strong>${escapeHtml(postingLabel)}:</strong>
//                 ${escapeHtml(postingValue)}
//               </li>

//             </ul>

//             <!-- SECTION 2 -->

//             <div class="section-title">

//               Section 2: Feedback for Sixth National Conference of Chief Secretaries

//             </div>

//             <!-- QUESTION 1 -->

//             <div class="feedback-section">

//               <div class="question-title">
//                 1. Name of the Topic
//               </div>

//               <div class="rich-content">

//                 ${getRichContent(nameOfTopic)}

//               </div>

//               ${getSubTopicsHtml()}

//             </div>

//             <!-- QUESTION 2 -->

//             <div class="feedback-section">

//               <div class="question-title">
//                 2. Policy Gaps and Challenges
//               </div>

//               <div class="rich-content">

//                 ${getRichContent(pgapsAndChallenges)}

//               </div>

//             </div>

//             <!-- QUESTION 3 -->

//             <div class="feedback-section">

//               <div class="question-title">
//                 3. Potential Solutions
//               </div>

//               <div class="rich-content">

//                 ${getRichContent(potentialSol)}

//               </div>

//             </div>

//             <!-- QUESTION 4 -->

//             <div class="feedback-section">

//               <div class="question-title">
//                 4. Best Practices
//               </div>

//               <div class="rich-content">

//                 ${getRichContent(bestPractices)}

//               </div>

//             </div>

//           </div>
//         `;

//       container = document.createElement("div"); container.id = "pdf-render-container"; container.innerHTML = html; container.style.position = "fixed"; container.style.left = "-10000px"; container.style.top = "0"; container.style.width = "794px"; container.style.margin = "0"; container.style.padding = "0"; container.style.backgroundColor = "#ffffff"; container.style.display = "block"; container.style.visibility = "visible"; container.style.opacity = "1"; container.style.pointerEvents = "none"; container.style.overflow = "visible"; document.body.appendChild(container);

//       await new Promise((resolve) => { requestAnimationFrame(() => { requestAnimationFrame(resolve); }); });

//       await new Promise((resolve) => setTimeout(resolve, 500));

//       const images = container.querySelectorAll("img");

//       await Promise.all(Array.from(images).map((img) => { return new Promise((resolve) => { if (img.complete && img.naturalWidth > 0) { resolve(); return; } img.onload = () => { resolve(); }; img.onerror = () => { console.warn("PDF image failed to load:", img.src.substring(0, 100)); resolve(); }; }); }));

//       await new Promise((resolve) => setTimeout(resolve, 300));

//       Array.from(images).forEach((img, index) => { console.log(`PDF Image ${index + 1}:`, { src: img.src.substring(0, 80), complete: img.complete, naturalWidth: img.naturalWidth, naturalHeight: img.naturalHeight, }); });

//       const pdfDocument = container.querySelector(".pdf-document");

//       if (!pdfDocument) { throw new Error("PDF document was not created."); }

//       const contentWidth = 794; const contentHeight = Math.max(pdfDocument.scrollHeight, pdfDocument.offsetHeight, 1123);

//       container.style.width = `${contentWidth}px`; container.style.height = `${contentHeight}px`; pdfDocument.style.width = `${contentWidth}px`; pdfDocument.style.minHeight = `${contentHeight}px`; pdfDocument.style.height = `${contentHeight}px`;

//       const canvasScaleFactor = 2;

//       const canvas =
//         await html2canvas(container, { scale: canvasScaleFactor, useCORS: true, allowTaint: false, backgroundColor: "#ffffff", logging: false, x: 0, y: 0, width: contentWidth, height: contentHeight, scrollX: 0, scrollY: 0, windowWidth: contentWidth, windowHeight: contentHeight, });

//       if (!canvas || canvas.width <= 0 || canvas.height <= 0) { throw new Error(`Invalid canvas: ${canvas?.width} x ${canvas?.height}`); }

//       const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4", compress: true, });
//       const pageWidth = 210; const pageHeight = 297; const imgWidth = pageWidth;

//       const getSafeBreakPointsPx = (pdfDocumentEl, scaleFactor) => {
//         const rootRect = pdfDocumentEl.getBoundingClientRect();

//         const blockSelectors = [".pdf-header", ".section-title", ".officer-details li", ".feedback-section", ".question-title", ".question-note", ".rich-content > *", ".rich-content li", ".rich-content tr",].join(", ");

//         const breaks =
//           new Set([0]);

//         pdfDocumentEl.querySelectorAll(blockSelectors).forEach((el) => {

//           const r =
//             el.getBoundingClientRect();

//           const bottom = Math.round((r.bottom - rootRect.top) * scaleFactor);

//           if (bottom > 0) { breaks.add(bottom); }

//         });

//         breaks.add(Math.round(pdfDocumentEl.scrollHeight * scaleFactor));

//         return Array.from(breaks).sort((a, b) => a - b);

//       };

//       const cropCanvas = (sourceCanvas, sy, sh) => { const cropped = document.createElement("canvas"); cropped.width = sourceCanvas.width; cropped.height = sh; const ctx = cropped.getContext("2d"); ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, cropped.width, cropped.height); ctx.drawImage(sourceCanvas, 0, sy, sourceCanvas.width, sh, 0, 0, sourceCanvas.width, sh); return cropped; };

//       const marginMm = 15; const mmPerCanvasPx = pageWidth / canvas.width; const breakPoints = getSafeBreakPointsPx(pdfDocument, canvasScaleFactor);

//       let cursor = 0; let pageIndex = 0;

//       while (cursor < canvas.height - 1) { const topMarginMm = pageIndex === 0 ? 0 : marginMm; const remainingPx = canvas.height - cursor; const fitsWithoutReservedBottomMargin = remainingPx * mmPerCanvasPx + topMarginMm <= pageHeight; const bottomMarginMm = fitsWithoutReservedBottomMargin ? 0 : marginMm; const availableMm = pageHeight - topMarginMm - bottomMarginMm; const availablePx = availableMm / mmPerCanvasPx; const limit = cursor + availablePx; let cut = breakPoints.filter((b) => b > cursor && b <= limit).pop(); if (!cut) { cut = Math.min(limit, canvas.height); } const sliceHeight = Math.min(cut - cursor, canvas.height - cursor); const pageCanvas = cropCanvas(canvas, cursor, sliceHeight); const pageImageData = pageCanvas.toDataURL("image/jpeg", 0.98); const sliceHeightMm = sliceHeight * mmPerCanvasPx; if (pageIndex > 0) { pdf.addPage(); } pdf.addImage(pageImageData, "JPEG", 0, topMarginMm, imgWidth, sliceHeightMm, undefined, "FAST"); cursor = cut; pageIndex += 1; }
//       console.log(
//         "Total pages:",
//         pageIndex
//       );

//       const filename = `Sixth_National_Conference_Feedback_${safeCfmsId || "Document"}.pdf`; pdf.save(filename);

//     } catch (error) { alert("Unable to generate PDF. Please try again."); }
//     finally {

//       if (container && container.parentNode) { container.parentNode.removeChild(container); }

//     }

//   };

export const downloadpdf = async (item, viewAsBook = false) => {
  try {
    const params = {
      mode: "dashboarddatadownload",
      userId: userid,
      districtId: item.district_id,
      deptId: item.dept_id,
      cfmsId: item.cfms_id,
      mobile: item.mobile,
      nameOfTopic: item.name_of_topic,
    };

    store.dispatch({ type: "SHOW_SPINNER" });

    const res = await KpiService.snccsFeedbackFormDashboard(params);

    if (
      res?.data?.SCODE !== "01" ||
      !Array.isArray(res?.data?.SDESC) ||
      res.data.SDESC.length === 0
    ) {
      console.log("No data found");
      return;
    }

    // =====================================================
    // MAIN RESPONSE
    // =====================================================

    const dataa = res.data.SDESC[0];

    // =====================================================
    // TOPIC
    // =====================================================

    const topicValue = String(dataa?.name_of_topic || "");

    const nameOfTopic = dataa?.topic_des || "";

    console.log("TOPIC ID:", topicValue);
    console.log("TOPIC NAME:", nameOfTopic);

    // =====================================================
    // GET SUBTOPICS FROM API
    // IMPORTANT:
    // Do NOT use dataa.name_of_sub_topic for this.
    // =====================================================

    let subTopicListData = [];

    if (topicValue) {
      try {
        const subTopicRes = await KpiService.snccsSubTopics(topicValue);

        subTopicListData = Array.isArray(subTopicRes?.data)
          ? subTopicRes.data
          : [];
      } catch (error) {
        console.error("Subtopic loading error:", error);

        subTopicListData = [];
      }
    }

    // =====================================================
    // NORMALIZE SUBTOPICS
    // =====================================================

    const subTopics = subTopicListData
      .map((sub) => ({
        id: sub?.id,
        name: sub?.value,
      }))
      .filter((sub) => sub.id !== undefined && sub.id !== null && sub.name);

    // =====================================================
    // SUBTOPIC NAMES
    // These names come from snccsSubTopics()
    // =====================================================

    // const subTopicNames =
    //   subTopics.map(
    //     (sub) => sub.name
    //   );

    // =====================================================
    // TOPIC 1 FEEDBACK
    // =====================================================

    // const topic1Feedback = [];

    // if (Number(topicValue) === 1) {
    //   subTopics.forEach((subTopic) => {
    //     const subTopicId =
    //       String(subTopic.id);

    //     let pgapsKey;
    //     let potentialSolKey;
    //     let bestPracticesKey;
    //     let otherSuggestionsKey;

    //     // =================================================
    //     // SUBTOPIC 11
    //     //
    //     // No _sub11 exists in the response.
    //     //
    //     // Therefore:
    //     //
    //     // 11 -> p_gaps_and_challenges
    //     // 11 -> potential_sol
    //     // 11 -> best_practices
    //     // 11 -> other_suggestions
    //     // =================================================

    //     if (subTopicId === "11") {
    //       pgapsKey =
    //         "p_gaps_and_challenges";

    //       potentialSolKey =
    //         "potential_sol";

    //       bestPracticesKey =
    //         "best_practices";

    //       otherSuggestionsKey =
    //         "other_suggestions";
    //     }

    //     // =================================================
    //     // ALL OTHER SUBTOPICS
    //     //
    //     // 12 -> *_sub12
    //     // 13 -> *_sub13
    //     // 14 -> *_sub14
    //     // 15 -> *_sub15
    //     // =================================================

    //     else {
    //       pgapsKey =
    //         `p_gaps_and_challenges_sub${subTopicId}`;

    //       potentialSolKey =
    //         `potential_sol_sub${subTopicId}`;

    //       bestPracticesKey =
    //         `best_practices_sub${subTopicId}`;

    //       otherSuggestionsKey =
    //         `other_suggestions_sub${subTopicId}`;
    //     }

    //     // =================================================
    //     // GET FEEDBACK VALUES
    //     // =================================================

    //     const pgaps =
    //       dataa?.[pgapsKey] || "";

    //     const potentialSol =
    //       dataa?.[potentialSolKey] || "";

    //     const bestPractices =
    //       dataa?.[bestPracticesKey] || "";

    //     const otherSuggestions =
    //       dataa?.[otherSuggestionsKey] || "";

    //     console.log(
    //       `SUBTOPIC ${subTopicId}:`,
    //       {
    //         name: subTopic.name,
    //         pgapsKey,
    //         potentialSolKey,
    //         bestPracticesKey,
    //         otherSuggestionsKey,
    //         pgaps,
    //         potentialSol,
    //         bestPractices,
    //         otherSuggestions,
    //       }
    //     );

    //     // =================================================
    //     // ADD TO PDF DATA
    //     // =================================================

    //     topic1Feedback.push({
    //       name:
    //         subTopic.name,

    //       subTopicId:
    //         subTopicId,

    //       pgapsAndChallenges:
    //         pgaps,

    //       potentialSol:
    //         potentialSol,

    //       bestPractices:
    //         bestPractices,

    //       otherSuggestions:
    //         otherSuggestions,
    //     });
    //   });
    // }

    // console.log(
    //   "FINAL TOPIC 1 FEEDBACK:",
    //   topic1Feedback
    // );

    // =====================================================
    // TOPIC 1 FEEDBACK
    // ONLY SUBTOPICS HAVING ACTUAL DATA WILL BE INCLUDED
    // =====================================================

    const hasActualData = (value) => {
      if (value === null || value === undefined) {
        return false;
      }
      const div = document.createElement("div");
      div.innerHTML = String(value);
      const cleaned = (div.textContent || div.innerText || "")
        .replace(/\u00A0/g, " ")
        .trim();
      return cleaned !== "";
    };
    const topic1Feedback = [];

    if (Number(topicValue) === 1) {
      subTopics.forEach((subTopic) => {
        const subTopicId = String(subTopic.id);

        let pgapsKey;
        let potentialSolKey;
        let bestPracticesKey;
        let otherSuggestionsKey;

        // =================================================
        // SUBTOPIC 11
        // Uses base fields
        // =================================================

        if (subTopicId === "11") {
          pgapsKey = "p_gaps_and_challenges";
          potentialSolKey = "potential_sol";
          bestPracticesKey = "best_practices";
          otherSuggestionsKey = "other_suggestions";
        }

        // =================================================
        // SUBTOPICS 12, 13, 14, 15...
        // Uses *_subXX fields
        // =================================================
        else {
          pgapsKey = `p_gaps_and_challenges_sub${subTopicId}`;

          potentialSolKey = `potential_sol_sub${subTopicId}`;

          bestPracticesKey = `best_practices_sub${subTopicId}`;

          otherSuggestionsKey = `other_suggestions_sub${subTopicId}`;
        }

        // =================================================
        // GET FEEDBACK VALUES
        // =================================================

        const pgaps = dataa?.[pgapsKey] || "";

        const potentialSol = dataa?.[potentialSolKey] || "";

        const bestPractices = dataa?.[bestPracticesKey] || "";

        const otherSuggestions = dataa?.[otherSuggestionsKey] || "";

        // =================================================
        // CHECK WHETHER THIS SUBTOPIC HAS ANY DATA
        // =================================================

        const hasResponse =
          hasActualData(pgaps) ||
          hasActualData(potentialSol) ||
          hasActualData(bestPractices) ||
          hasActualData(otherSuggestions);

        console.log(`SUBTOPIC ${subTopicId}:`, {
          name: subTopic.name,
          pgaps,
          potentialSol,
          bestPractices,
          otherSuggestions,
          hasResponse,
        });

        // =================================================
        // IMPORTANT:
        // IF ALL 4 FIELDS ARE EMPTY,
        // DO NOT ADD THIS SUBTOPIC TO PDF
        // =================================================

        if (!hasResponse) {
          return;
        }

        // =================================================
        // ADD ONLY SUBTOPICS HAVING DATA
        // =================================================

        topic1Feedback.push({
          name: subTopic.name,
          subTopicId: subTopicId,
          pgapsAndChallenges: pgaps,
          potentialSol: potentialSol,
          bestPractices: bestPractices,
          otherSuggestions: otherSuggestions,
        });
      });
    }

    // =====================================================
    // SUBTOPIC NAMES
    // ONLY FROM SUBTOPICS HAVING ACTUAL FEEDBACK
    // =====================================================

    const subTopicNames = topic1Feedback.map((sub) => sub.name);

    console.log("FINAL TOPIC 1 FEEDBACK:", topic1Feedback);

    console.log("FINAL SUBTOPIC NAMES:", subTopicNames);

    // =====================================================
    // TOPIC 2 MATRIX
    // =====================================================

    const suggestedActionMatrix =
      Number(topicValue) === 2 && Array.isArray(res?.data?.topicsWiseMatrixData)
        ? res.data.topicsWiseMatrixData
        : [];

    console.log("SUGGESTED ACTION MATRIX:", suggestedActionMatrix);

    // =====================================================
    // DOCUMENT DATA
    // =====================================================

    const documentData = {
      // =================================================
      // OFFICER DETAILS
      // =================================================

      cfmsId: dataa?.cfms_id || "",

      fname: dataa?.f_name || "",

      designation: dataa?.designation || "",

      batchYear: dataa?.batch_year || "",

      currentServiceStatus: dataa?.current_service_status || "",

      trainingInstitute: dataa?.training_institute || "",

      currentPosting: dataa?.current_posting || "",

      // =================================================
      // TOPIC
      // =================================================

      topicValue: topicValue,

      nameOfTopic: nameOfTopic,

      // =================================================
      // SUBTOPICS
      // =================================================
      subTopicNames: subTopicNames,

      // =================================================
      // TOPIC 1 SUBTOPIC FEEDBACK
      // =================================================

      topic1Feedback: topic1Feedback,

      // =================================================
      // GENERAL FEEDBACK
      //
      // For subtopic 11 these are also the values used
      // for the first subtopic.
      // =================================================

      pgapsAndChallenges: dataa?.p_gaps_and_challenges || "",

      potentialSol: dataa?.potential_sol || "",

      bestPractices: dataa?.best_practices || "",

      otherSuggestions: dataa?.other_suggestions || "",

      // =================================================
      // TOPIC 2 MATRIX
      // =================================================

      suggestedActionMatrix: suggestedActionMatrix,

      is_eval_required:
        dataa?.is_eval_required ?? item?.is_eval_required ?? false,

      eval_grade: dataa?.eval_grade ?? item?.eval_grade ?? null,
      eval_remarks: dataa?.eval_remarks ?? item?.eval_remarks ?? "",
      ratingCfmsId: dataa?.cfms_id || item?.cfms_id || "",
      ratingTopicId: dataa?.name_of_topic || item?.name_of_topic || "",
    };

    console.log("FINAL DOCUMENT DATA:", documentData);

    // =====================================================
    // GENERATE PDF
    // =====================================================

    if (viewAsBook) {
      window.dispatchEvent(
        new CustomEvent("feedback-book-open", {
          detail: {
            documentData,
            downloadItem: item,
          },
        }),
      );
    } else {
      await generatePdfDocument(documentData);
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
  } finally {
    store.dispatch({
      type: "HIDE_SPINNER",
    });
  }
};
export const generatePdfDocument = async (data) => {
  let container = null;

  try {

    const { cfmsId, fname, designation, batchYear, currentServiceStatus, trainingInstitute, currentPosting, nameOfTopic, subTopicNames, topic1Feedback, pgapsAndChallenges, potentialSol, bestPractices, otherSuggestions, suggestedActionMatrix, } = data || {};

    const safeText = (value) => { if (value === null || value === undefined) { return ""; } return String(value); };

    const escapeHtml = (value) => { return safeText(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;"); };

    const safeCfmsId = safeText(cfmsId).replace(/[^a-zA-Z0-9_-]/g, "").trim();

    const sanitizeRichText = (value) => {
      if (!value) { return ""; }

      try {
        const parser = new DOMParser();

        const doc = parser.parseFromString(`<div>${safeText(value)}</div>`, "text/html",);

        const root = doc.body.firstElementChild; if (!root) { return escapeHtml(value).replace(/\n/g, "<br>"); }

        root.querySelectorAll("script, style, iframe, object, embed, link, meta, noscript",).forEach((el) => el.remove());

        const allowedTags = new Set(["P", "BR", "STRONG", "B", "EM", "I", "U", "UL", "OL", "LI", "TABLE", "THEAD", "TBODY", "TFOOT", "TR", "TH", "TD", "DIV", "SPAN", "IMG",]);

        const cleanNode = (node) => {
          if (node.nodeType === Node.TEXT_NODE) { return escapeHtml(node.textContent); }
          if (node.nodeType !== Node.ELEMENT_NODE) { return ""; }
          const tag = node.tagName.toUpperCase();

          if (!allowedTags.has(tag)) { return Array.from(node.childNodes).map(cleanNode).join(""); }

          if (tag === "IMG") {
            const src = node.getAttribute("src"); if (!src || !src.startsWith("data:image/")) { return ""; }

            return `
  <img
    src="${src}"
    style="
      width: 180px;
      max-width: 180px;
      height: auto;
      display: block;
      margin: 6pt 0;
    "
    alt=""
  />
`;
          }

          if (tag === "BR") { return "<br>"; }

          if (tag === "TABLE") { return ` <table> ${Array.from(node.childNodes).map(cleanNode).join("")} </table> `; }

          if (tag === "TH" || tag === "TD") { return ` <${tag.toLowerCase()}> ${Array.from(node.childNodes).map(cleanNode).join("")} </${tag.toLowerCase()}> `; }

          return ` <${tag.toLowerCase()}> ${Array.from(node.childNodes).map(cleanNode).join("")} </${tag.toLowerCase()}> `;
        };

        return Array.from(root.childNodes).map(cleanNode).join("").trim();
      } catch (error) { return escapeHtml(value).replace(/\n/g, "<br>"); }
    };

    const getSubTopicsHtml = () => {
      if (!Array.isArray(subTopicNames) || subTopicNames.length === 0) { return ""; }

      return `
    <div class="sub-topic-section">
 
      <div class="sub-topic-label">
        Specific Priority Area(s):
      </div>
 
      <ol class="sub-topic-list">
        ${subTopicNames
          .map(
            (subTopic, index) => `
              <li>
                ${index + 1}.1 ${escapeHtml(subTopic)}
              </li>
            `,
          )
          .join("")}
      </ol>
 
    </div>
  `;
    };
    const getTopic1FeedbackHtml = () => {
      if (!Array.isArray(topic1Feedback) || topic1Feedback.length === 0) { return ""; }

      return `
    <div class="topic1-feedback-wrapper">
 
      ${topic1Feedback.map((sub, index) => {
        const areaNo = index + 1;

        return `
            <div class="topic1-subtopic">
 
              <div class="topic1-subtopic-title"> Specific Priority Area ${areaNo}: </div>
 
              <!-- Sub Topic -->
              <div class="topic1-subtopic-name"> ${escapeHtml(sub.name || `Sub Topic ${areaNo}`)} </div>
 
              <!-- Policy Gaps -->
              <div class="topic1-question">
                <div class="topic1-question-title"> ${areaNo}.2 Policy Gaps and Challenges </div>
 
                <div class="rich-content topic1-content"> ${getRichContent(sub.pgapsAndChallenges || "Not provided")} </div>
              </div>
 
              <!-- Potential Solutions -->
              <div class="topic1-question">
                <div class="topic1-question-title"> ${areaNo}.3 Potential Solutions </div>
 
                <div class="rich-content topic1-content"> ${getRichContent(sub.potentialSol || "Not provided")} </div>
              </div>
 
              <!-- Best Practices -->
              <div class="topic1-question">
                <div class="topic1-question-title"> ${areaNo}.4 Best Practices </div>
 
                <div class="rich-content topic1-content"> ${getRichContent(sub.bestPractices || "Not provided")} </div>
              </div>
 
         ${hasActualData(sub.otherSuggestions)
            ? `
      <div class="topic1-question">
        <div class="topic1-question-title"> ${areaNo}.5 Other Suggestions </div>
 
        <div class="rich-content topic1-content"> ${getRichContent(sub.otherSuggestions)} </div>
      </div>
    `
            : ""
          }
            </div>
          `;
      })
          .join("")}
 
    </div>
  `;
    };

    const getRichContent = (value) => { const result = sanitizeRichText(value); if (!result) { return ` <p class="empty-content"> Not provided </p> `; } return result; };
    const cellStyle = "border-right:1px solid #000;border-bottom:1px solid #000;padding:6px 8px;vertical-align:top;text-align:left;";
    const thStyle = "border-right:1px solid #000;border-bottom:1px solid #000;padding:6px 8px;text-align:center;font-weight:700;background:#f3f3f3;";



    const hasActualData = (value) => { if (value === null || value === undefined) { return false; } const div = document.createElement("div"); div.innerHTML = String(value); const cleaned = (div.textContent || div.innerText || "").replace(/\u00A0/g, " ").trim(); return cleaned !== ""; };
    const hasMatrixRowData = (row) => { if (!row || typeof row !== "object") { return false; } return (hasActualData(row.issue) || hasActualData(row.proposed_action) || hasActualData(row.lead_agency) || hasActualData(row.supporting_agencies) || hasActualData(row.expected_outcome_timeline)); };

    const getSuggestedActionMatrixHtml = () => {
      if (!Array.isArray(suggestedActionMatrix) || suggestedActionMatrix.length === 0) { return ""; }

      const validRows = suggestedActionMatrix.filter((row) => hasMatrixRowData(row),);

      if (validRows.length === 0) { return ""; }



      return `
    <div class="suggested-action-matrix">
 
      <div class="question-title">
        5. Suggested Action Matrix
      </div>
 
      <table class="action-matrix-table" style=" width:100%; table-layout:fixed; border-collapse:separate; border-spacing:0; border-top:1px solid #000; border-left:1px solid #000; " >
 
        <thead> <tr> <th style="${thStyle}"> Issue </th> <th style="${thStyle}"> Proposed Action </th> <th style="${thStyle}"> Lead Agency </th> <th style="${thStyle}"> Supporting Agencies </th> <th style="${thStyle}"> Expected Outcome / Timeline </th> </tr> </thead>
 
        <tbody>
 
          ${validRows.map((row) => `
                <tr>
 
                  <td style="${cellStyle}"> ${hasActualData(row.issue) ? getRichContent(row.issue) : ""} </td> <td style="${cellStyle}"> ${hasActualData(row.proposed_action) ? getRichContent(row.proposed_action) : ""} </td>
 
                  <td style="${cellStyle}"> ${hasActualData(row.lead_agency) ? getRichContent(row.lead_agency) : ""} </td> <td style="${cellStyle}"> ${hasActualData(row.supporting_agencies) ? getRichContent(row.supporting_agencies) : ""} </td>
 
                  <td style="${cellStyle}"> ${hasActualData(row.expected_outcome_timeline) ? getRichContent(row.expected_outcome_timeline) : ""} </td>
 
                </tr>
              `,
      )
          .join("")}
 
        </tbody>
      </table>
 
    </div>
  `;
    };
    const hasOtherSuggestions = hasActualData(otherSuggestions);

    const getImageAsBase64 = async (imageUrl) => {
      try {
        const response = await fetch(imageUrl);

        if (!response.ok) { throw new Error(`Failed to load image: ${response.status}`); }

        const blob = await response.blob();

        return await new Promise((resolve, reject) => { const reader = new FileReader(); reader.onloadend = () => { resolve(reader.result); }; reader.onerror = reject; reader.readAsDataURL(blob); });
      } catch (error) { console.error("Logo loading failed:", error); return ""; }
    };

    const logoBase64 = await getImageAsBase64(`${window.location.origin}/images/nitiaayog.png`,);

    const status = safeText(currentServiceStatus).trim(); const isProbationer = status.toLowerCase() === "probationer" || status === "1";

    const postingLabel = isProbationer ? "Training Institute / Academy" : "Current Posting"; const postingValue = isProbationer ? trainingInstitute : currentPosting;



    const html = `
 
      <style>
 
        * {
          box-sizing: border-box;
        }
 
        html,
        body {
          margin: 0;
          padding: 0;
          background: #ffffff;
        }
 
        .pdf-document {
 
          width: 794px;
 
          min-height: 1123px;
 
          padding: 15mm;
 
          margin: 0;
 
          background: #ffffff;
 
          color: #111111;
 
          font-family:
            "Times New Roman",
            Times,
            serif;
 
          font-size: 11pt;
 
          line-height: 1.25;
        }
 
        /* =====================================================
           HEADER
           ===================================================== */
 
        .pdf-header { text-align: center; margin-bottom: 32px; padding-top: 4px; }
 
        .logo-wrapper { text-align: center; height: 100px; margin-bottom: 18px; display: flex; justify-content: center; align-items: center; }
        .logo { width: 82px; height: 72px; object-fit: contain; display: block; }
 
        .main-title,
        .sub-title { font-family: "Times New Roman", Times, serif; font-size: 14pt; font-weight: 700; line-height: 1.25; text-align: center; display: block; color: #000000; }
 
        .main-title { margin: 0; padding: 0; color: #000000; }
 
        .sub-title { margin-top: 6pt; }
 
        /* =====================================================
           SECTION HEADINGS
           ===================================================== */
 
        .section-title { font-family: "Times New Roman", Times, serif; font-size: 12pt; font-weight: 700; margin-top: 14pt; margin-bottom: 6pt; line-height: 1.25; }
        /* =====================================================
           OFFICER DETAILS
           ===================================================== */
 
        .officer-details { margin: 0; padding-left: 28px; font-family: "Times New Roman", Times, serif; font-size: 11pt; line-height: 1.25; }
 
        .officer-details li { margin-bottom: 3pt; padding-left: 1px; }
 
        .officer-details strong { font-weight: 700; }
 
        /* =====================================================
           FEEDBACK SECTION
           ===================================================== */
 
        .feedback-section { margin-top: 9pt; margin-bottom: 0; padding-bottom: 0; }
 
        .question-title { font-family: "Times New Roman", Times, serif; font-size: 12pt; font-weight: 700; line-height: 1.25; margin-top: 10pt; margin-bottom: 8pt; padding: 0; }
        .question-note { font-size: 11pt; font-style: italic; color: #666666; line-height: 1.25; margin-top: 0; margin-bottom: 6pt; }
 
        /* =====================================================
           RICH CONTENT
           ===================================================== */
 
        .rich-content { font-family: "Times New Roman", Times, serif; font-size: 11pt; line-height: 1.25; color: #222222; word-wrap: break-word; overflow-wrap: break-word; margin-left: 30px; margin-top: 0; padding: 0; }
 
        .rich-content p { margin-top: 0; margin-bottom: 6pt; padding: 0; }
 
        /* =====================================================
           BASE64 IMAGES
           ===================================================== */
 
     .rich-content img { width: 180px; max-width: 180px; height: auto; display: block; margin: 6pt 0; }
 
        /* =====================================================
           BULLET / NUMBERED LISTS
           ===================================================== */
 
        .rich-content ul { margin-top: 3px; margin-bottom: 6pt; padding-left: 40px; }
 
        .rich-content ol { margin-top: 3px; margin-bottom: 6pt; padding-left: 40px; }
 
        .rich-content li { margin-bottom: 3px; padding-left: 3px; }
 
        .rich-content li ul,
        .rich-content li ol { padding-left: 30px; }
        /* =====================================================
           TABLES
           ===================================================== */
 
        .rich-content table { width: 100%; border-collapse: collapse; margin-top: 8px; margin-bottom: 10px; }
 
        .rich-content th,
        .rich-content td { border: 1px solid #999999; padding: 5px 7px; vertical-align: top; font-size: 10.5pt; line-height: 1.25; }
 
        .rich-content th { font-weight: 700; background: #f3f3f3; }
 
        .empty-content { color: #777777; font-style: italic; margin: 0; }
 
        /* =====================================================
           SUB TOPICS
           ===================================================== */
 
        .sub-topic-section { margin-left: 30px; margin-top: 4pt; margin-bottom: 8pt; font-family: "Times New Roman", Times, serif; font-size: 11pt; line-height: 1.25; }
 
        .sub-topic-label { font-weight: 700; margin-bottom: 3pt; }
 
        .sub-topic-list { margin-top: 2pt; margin-bottom: 0; padding-left: 28px; }
 
        .sub-topic-list li { margin-bottom: 3pt; padding-left: 3px; line-height: 1.25; }
 /* =====================================================
   TOPIC 1 - SUB TOPIC FEEDBACK
   ===================================================== */
 
/* =====================================================
   TOPIC 1 - SUB TOPIC FEEDBACK
   ===================================================== */
 
.topic1-feedback-wrapper { margin-top: 8pt; }
 
.topic1-subtopic { margin-left: 30px; margin-bottom: 16pt; page-break-inside: avoid; break-inside: avoid; }
 
.topic1-subtopic-title { font-size: 11.5pt; font-weight: 700; margin-top: 8pt; margin-bottom: 6pt; line-height: 1.3; }
 
.topic1-question { margin-left: 18px; margin-top: 5pt; margin-bottom: 6pt; }
 
.topic1-question-title { font-size: 11pt; font-weight: 700; margin-bottom: 2pt; }
 
.topic1-content { margin-left: 18px; }
 
.suggested-action-matrix { margin-top: 4pt; margin-bottom: 8pt; }
 
.action-matrix-table { width: 100%; table-layout: fixed; border-collapse: separate !important; border-spacing: 0 !important; border-top: 1px solid #000 !important; border-left: 1px solid #000 !important; font-family: "Times New Roman", Times, serif; font-size: 10pt; }
 
.action-matrix-table th, .action-matrix-table td { border-right: 1px solid #000 !important; border-bottom: 1px solid #000 !important; border-top: none !important; border-left: none !important; padding: 6px 8px; vertical-align: top; text-align: left; line-height: 1.25; word-wrap: break-word; overflow-wrap: break-word; background: #fff; }
 
.action-matrix-table th { font-weight: 700; text-align: center; background: #f3f3f3; }
 
.action-matrix-table td p { margin: 0; }
 
.action-matrix-table td ul, .action-matrix-table td ol { margin: 2pt 0; padding-left: 16px; }
 
.action-matrix-table th:nth-child(1), .action-matrix-table td:nth-child(1) { width: 18%; }
.action-matrix-table th:nth-child(2), .action-matrix-table td:nth-child(2) { width: 25%; }
.action-matrix-table th:nth-child(3), .action-matrix-table td:nth-child(3) { width: 18%; }
.action-matrix-table th:nth-child(4), .action-matrix-table td:nth-child(4) { width: 21%; }
.action-matrix-table th:nth-child(5), .action-matrix-table td:nth-child(5) { width: 18%; }
      </style>
 
      <div class="pdf-document">
 
        <!-- HEADER -->
 
        <div class="pdf-header">
 
          ${logoBase64
        ? `
                <div class="logo-wrapper">
 
                  <img
                    class="logo"
                    src="${logoBase64}"
                    alt="NITI Aayog"
                  />
 
                </div>
              `
        : ""
      }
 
          <div class="main-title"> Sixth National Conference of Chief Secretaries </div>
 
          <div class="sub-title"> Feedback Note </div>
 
        </div>
 
        <!-- SECTION 1 -->
 
        <div class="section-title"> Section 1: Officer Name and Details </div>
 
        <ul class="officer-details">
 
          <li> <strong>Name:</strong> ${escapeHtml(fname)} </li>
 <li> <strong>Designation:</strong> ${escapeHtml(designation)} </li>
 
          <li> <strong>Batch:</strong> ${escapeHtml(batchYear)} </li>
 
          <li> <strong>Current Service Status:</strong> ${escapeHtml(currentServiceStatus)} </li>
 
          <li> <strong>${escapeHtml(postingLabel)}:</strong> ${escapeHtml(postingValue)} </li>
 
        </ul>
 
        <!-- SECTION 2 -->
 
        <div class="section-title"> Section 2: Feedback for Sixth National Conference of Chief Secretaries </div>
 
        <!-- QUESTION 1 -->
 
        <div class="feedback-section">
 
          <div class="question-title"> 1. Name of the Topic </div>
 
                <div class="rich-content"> ${getRichContent(nameOfTopic)} </div>
 
${!topic1Feedback?.length ? getSubTopicsHtml() : ""}
 
        </div>
 
 
 
<!-- =====================================================
     TOPIC 1
     ===================================================== -->
 
${Array.isArray(topic1Feedback) && topic1Feedback.length > 0
        ? `
     
      ${getTopic1FeedbackHtml()}
 
    `
        : `
 
      <!-- =================================================
           TOPIC 2, 3, 4
           NORMAL FEEDBACK
           ================================================= -->
 
      <!-- QUESTION 2 -->
      <div class="feedback-section">
 
        <div class="question-title">
          2. Policy Gaps and Challenges
        </div>
 
        <div class="rich-content"> ${getRichContent(pgapsAndChallenges)} </div>
 
      </div>
 
 
      <!-- QUESTION 3 -->
      <div class="feedback-section">
 
        <div class="question-title"> 3. Potential Solutions </div>
 
        <div class="rich-content"> ${getRichContent(potentialSol)} </div>
 
      </div>
 
 
      <!-- QUESTION 4 -->
      <div class="feedback-section">
 
        <div class="question-title">
          4. Best Practices
        </div>
 
        <div class="rich-content">
          ${getRichContent(bestPractices)}
        </div>
 
      </div>
 
 
      <!-- QUESTION 5 -->
<!-- QUESTION 5 -->
 
${Number(data?.topicValue) === 2
          ? getSuggestedActionMatrixHtml()
          : hasOtherSuggestions
            ? `
        <div class="feedback-section">
 
          <div class="question-title">
            5. Other Suggestions
          </div>
 
          <div class="rich-content">
            ${getRichContent(otherSuggestions)}
          </div>
 
        </div>
      `
            : ""
        }
 
    `
      }
      </div>
    `;

    // =========================================================
    // PDF CONTAINER
    // =========================================================

    container = document.createElement("div");

    container.id = "pdf-render-container";

    container.innerHTML = html;

    container.style.position = "fixed";

    container.style.left = "-10000px";

    container.style.top = "0";

    container.style.width = "794px";

    container.style.margin = "0";

    container.style.padding = "0";

    container.style.backgroundColor = "#ffffff";

    container.style.display = "block";

    container.style.visibility = "visible";

    container.style.opacity = "1";

    container.style.pointerEvents = "none";

    container.style.overflow = "visible";

    document.body.appendChild(container);

    // =========================================================
    // WAIT FOR RENDER
    // =========================================================

    await new Promise((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(resolve);
      });
    });

    await new Promise((resolve) => setTimeout(resolve, 500));

    // =========================================================
    // WAIT FOR ALL IMAGES
    // =========================================================

    const images = container.querySelectorAll("img");

    console.log("PDF images found:", images.length);

    await Promise.all(
      Array.from(images).map((img) => {
        return new Promise((resolve) => {
          // Already loaded
          if (img.complete && img.naturalWidth > 0) {
            resolve();

            return;
          }

          img.onload = () => {
            resolve();
          };

          img.onerror = () => {
            console.warn(
              "PDF image failed to load:",
              img.src.substring(0, 100),
            );

            resolve();
          };
        });
      }),
    );

    // Give browser one more render cycle
    await new Promise((resolve) => setTimeout(resolve, 300));

    // Debug image information
    Array.from(images).forEach((img, index) => {
      console.log(`PDF Image ${index + 1}:`, {
        src: img.src.substring(0, 80),
        complete: img.complete,
        naturalWidth: img.naturalWidth,
        naturalHeight: img.naturalHeight,
      });
    });

    // =========================================================
    // GET DOCUMENT
    // =========================================================

    const pdfDocument = container.querySelector(".pdf-document");

    if (!pdfDocument) {
      throw new Error("PDF document was not created.");
    }

    // =========================================================
    // CALCULATE HEIGHT
    // =========================================================

    const contentWidth = 794;

    const contentHeight = Math.max(
      pdfDocument.scrollHeight,
      pdfDocument.offsetHeight,
      1123,
    );

    container.style.width = `${contentWidth}px`;

    container.style.height = `${contentHeight}px`;

    pdfDocument.style.width = `${contentWidth}px`;

    pdfDocument.style.minHeight = `${contentHeight}px`;

    pdfDocument.style.height = `${contentHeight}px`;

    console.log("PDF width:", contentWidth);

    console.log("PDF height:", contentHeight);

    // =========================================================
    // HTML2CANVAS
    // =========================================================

    const canvasScaleFactor = 2;

    const canvas = await html2canvas(container, {
      scale: canvasScaleFactor,

      useCORS: true,

      allowTaint: false,

      backgroundColor: "#ffffff",

      logging: false,

      x: 0,

      y: 0,

      width: contentWidth,

      height: contentHeight,

      scrollX: 0,

      scrollY: 0,

      windowWidth: contentWidth,

      windowHeight: contentHeight,
    });

    if (!canvas || canvas.width <= 0 || canvas.height <= 0) {
      throw new Error(`Invalid canvas: ${canvas?.width} x ${canvas?.height}`);
    }

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
      compress: true,
    });

    const pageWidth = 210;
    const pageHeight = 297;
    const imgWidth = pageWidth;

    // =========================================================
    // SAFE BREAK POINTS
    // =========================================================
    const getSafeBreakPointsPx = (pdfDocumentEl, scaleFactor) => {
      const rootRect = pdfDocumentEl.getBoundingClientRect();

      const blockSelectors = [
        ".pdf-header",
        ".officer-details li",
        ".feedback-section",
        ".topic1-question",
        ".question-note",
        ".rich-content > *",
        ".rich-content li",
        ".rich-content tr",
        ".action-matrix-table tbody tr", // rows of the matrix table
        ".suggested-action-matrix", // end of the whole matrix block
      ].join(", ");

      // NOTE: .section-title and .question-title are intentionally NOT here.
      // A break right after a heading strands it at the bottom of a page.

      const breaks = new Set([0]);

      pdfDocumentEl.querySelectorAll(blockSelectors).forEach((el) => {
        const r = el.getBoundingClientRect();
        const bottom = Math.round((r.bottom - rootRect.top) * scaleFactor);
        if (bottom > 0) breaks.add(bottom);
      });

      breaks.add(Math.round(pdfDocumentEl.scrollHeight * scaleFactor));

      return Array.from(breaks).sort((a, b) => a - b);
    };

    const cropCanvas = (sourceCanvas, sy, sh) => {
      const cropped = document.createElement("canvas");

      cropped.width = sourceCanvas.width;

      cropped.height = sh;

      const ctx = cropped.getContext("2d");

      ctx.fillStyle = "#ffffff";

      ctx.fillRect(0, 0, cropped.width, cropped.height);

      ctx.drawImage(
        sourceCanvas,

        0,
        sy,

        sourceCanvas.width,
        sh,

        0,
        0,

        sourceCanvas.width,
        sh,
      );

      return cropped;
    };

    // =========================================================
    // ADD PAGES
    // =========================================================

    const marginMm = 15;

    const mmPerCanvasPx = pageWidth / canvas.width;

    const breakPoints = getSafeBreakPointsPx(pdfDocument, canvasScaleFactor);

    let cursor = 0;

    let pageIndex = 0;

    while (cursor < canvas.height - 1) {
      const topMarginMm = pageIndex === 0 ? 0 : marginMm;

      const remainingPx = canvas.height - cursor;

      const fitsWithoutReservedBottomMargin =
        remainingPx * mmPerCanvasPx + topMarginMm <= pageHeight;

      const bottomMarginMm = fitsWithoutReservedBottomMargin ? 0 : marginMm;

      const availableMm = pageHeight - topMarginMm - bottomMarginMm;

      const availablePx = availableMm / mmPerCanvasPx;

      const limit = cursor + availablePx;

      let cut = breakPoints.filter((b) => b > cursor && b <= limit).pop();

      if (!cut) {
        cut = Math.min(limit, canvas.height);
      }

      const sliceHeight = Math.min(cut - cursor, canvas.height - cursor);

      const pageCanvas = cropCanvas(canvas, cursor, sliceHeight);

      const pageImageData = pageCanvas.toDataURL("image/jpeg", 0.98);

      const sliceHeightMm = sliceHeight * mmPerCanvasPx;

      if (pageIndex > 0) {
        pdf.addPage();
      }

      pdf.addImage(
        pageImageData,

        "JPEG",

        0,

        topMarginMm,

        imgWidth,

        sliceHeightMm,

        undefined,

        "FAST",
      );

      cursor = cut;

      pageIndex += 1;
    }

    // =========================================================
    // SAVE
    // =========================================================
    const safeName = safeText(fname)
      .trim()
      .replace(/\b([A-Za-z])[\s._]+(?=[A-Za-z]\b)/g, "$1")
      .replace(/[^a-zA-Z0-9 ]/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    const filename = `${safeName || "Officer"}_Sixth_National_Conference_Feedback_${safeCfmsId || "Document"}.pdf`;

    pdf.save(filename);

    console.log("PDF generated successfully:", filename);
  } catch (error) {
    console.error("PDF generation failed:", error);

    console.error("PDF generation error stack:", error?.stack);

    alert("Unable to generate PDF. Please try again.");
  } finally {
    // =========================================================
    // CLEANUP
    // =========================================================

    if (container && container.parentNode) {
      container.parentNode.removeChild(container);
    }

    console.log("PDF temporary elements cleaned");
  }
};

export const generatePdfBlobDocument = async (data) => {
  let container = null;

  try {
    console.log("PDF DATA:", data);

    const {
      cfmsId,
      fname,
      designation,
      batchYear,
      currentServiceStatus,
      trainingInstitute,
      currentPosting,
      nameOfTopic,
      subTopicNames,
      topic1Feedback,
      pgapsAndChallenges,
      potentialSol,
      bestPractices,
      otherSuggestions,
      suggestedActionMatrix,
    } = data || {};

    const safeText = (value) =>
      value === null || value === undefined ? "" : String(value);
    const escapeHtml = (value) =>
      safeText(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");

    const hasActualData = (value) => {
      if (value === null || value === undefined) return false;
      const div = document.createElement("div");
      div.innerHTML = String(value);
      return (
        (div.textContent || div.innerText || "")
          .replace(/\u00A0/g, " ")
          .trim() !== ""
      );
    };

    const sanitizeRichText = (value) => {
      if (!value) return "";
      try {
        const doc = new DOMParser().parseFromString(
          `<div>${safeText(value)}</div>`,
          "text/html",
        );
        const root = doc.body.firstElementChild;
        if (!root) return escapeHtml(value).replace(/\n/g, "<br>");

        root
          .querySelectorAll(
            "script, style, iframe, object, embed, link, meta, noscript",
          )
          .forEach((el) => el.remove());

        const allowedTags = new Set([
          "P",
          "BR",
          "STRONG",
          "B",
          "EM",
          "I",
          "U",
          "UL",
          "OL",
          "LI",
          "TABLE",
          "THEAD",
          "TBODY",
          "TFOOT",
          "TR",
          "TH",
          "TD",
          "DIV",
          "SPAN",
          "IMG",
        ]);

        const cleanNode = (node) => {
          if (node.nodeType === Node.TEXT_NODE)
            return escapeHtml(node.textContent);
          if (node.nodeType !== Node.ELEMENT_NODE) return "";

          const tag = node.tagName.toUpperCase();
          const children = () =>
            Array.from(node.childNodes).map(cleanNode).join("");

          if (!allowedTags.has(tag)) return children();

          if (tag === "IMG") {
            const src = node.getAttribute("src");
            if (!src || !src.startsWith("data:image/")) return "";
            return `<img src="${src}" style="width:180px;max-width:180px;height:auto;display:block;margin:6pt 0;" alt="" />`;
          }

          if (tag === "BR") return "<br>";

          const t = tag.toLowerCase();
          return `<${t}>${children()}</${t}>`;
        };

        return Array.from(root.childNodes).map(cleanNode).join("").trim();
      } catch (error) {
        return escapeHtml(value).replace(/\n/g, "<br>");
      }
    };

    const getRichContent = (value) => {
      const result = sanitizeRichText(value);
      return result || `<p class="empty-content">Not provided</p>`;
    };

    // ---------------------------------------------------------
    // SECTION BUILDERS
    // ---------------------------------------------------------
    const getSubTopicsHtml = () => {
      if (!Array.isArray(subTopicNames) || subTopicNames.length === 0)
        return "";
      return `
        <div class="sub-topic-section">
          <div class="sub-topic-label">Specific Priority Area(s):</div>
          <ol class="sub-topic-list">
            ${subTopicNames.map((subTopic, index) => `<li>${index + 1}.1 ${escapeHtml(subTopic)}</li>`).join("")}
          </ol>
        </div>`;
    };

    const getTopic1FeedbackHtml = () => {
      if (!Array.isArray(topic1Feedback) || topic1Feedback.length === 0)
        return "";

      const question = (title, content) => `
        <div class="topic1-question">
          <div class="topic1-question-title">${title}</div>
          <div class="rich-content topic1-content">${content}</div>
        </div>`;

      return `
        <div class="topic1-feedback-wrapper">
          ${topic1Feedback
          .map((sub, index) => {
            const areaNo = index + 1;
            return `
                <div class="topic1-subtopic">
                  <div class="topic1-subtopic-title">Specific Priority Area ${areaNo}:</div>
                  <div class="topic1-subtopic-name">${escapeHtml(sub.name || `Sub Topic ${areaNo}`)}</div>
                  ${question(`${areaNo}.2 Policy Gaps and Challenges`, getRichContent(sub.pgapsAndChallenges || "Not provided"))}
                  ${question(`${areaNo}.3 Potential Solutions`, getRichContent(sub.potentialSol || "Not provided"))}
                  ${question(`${areaNo}.4 Best Practices`, getRichContent(sub.bestPractices || "Not provided"))}
                  ${hasActualData(sub.otherSuggestions) ? question(`${areaNo}.5 Other Suggestions`, getRichContent(sub.otherSuggestions)) : ""}
                </div>`;
          })
          .join("")}
        </div>`;
    };

    const cellStyle =
      "border-right:1px solid #000;border-bottom:1px solid #000;padding:6px 8px;vertical-align:top;text-align:left;";
    const thStyle =
      "border-right:1px solid #000;border-bottom:1px solid #000;padding:6px 8px;text-align:center;font-weight:700;background:#f3f3f3;";

    const hasMatrixRowData = (row) =>
      !!row &&
      typeof row === "object" &&
      (hasActualData(row.issue) ||
        hasActualData(row.proposed_action) ||
        hasActualData(row.lead_agency) ||
        hasActualData(row.supporting_agencies) ||
        hasActualData(row.expected_outcome_timeline));

    const getSuggestedActionMatrixHtml = () => {
      if (
        !Array.isArray(suggestedActionMatrix) ||
        suggestedActionMatrix.length === 0
      )
        return "";

      const validRows = suggestedActionMatrix.filter(hasMatrixRowData);
      if (validRows.length === 0) return "";

      const cell = (value) =>
        `<td style="${cellStyle}">${hasActualData(value) ? getRichContent(value) : ""}</td>`;

      return `
        <div class="suggested-action-matrix">
          <div class="question-title">5. Suggested Action Matrix</div>
          <table class="action-matrix-table" style="width:100%;table-layout:fixed;border-collapse:separate;border-spacing:0;border-top:1px solid #000;border-left:1px solid #000;">
            <thead>
              <tr>
                <th style="${thStyle}">Issue</th>
                <th style="${thStyle}">Proposed Action</th>
                <th style="${thStyle}">Lead Agency</th>
                <th style="${thStyle}">Supporting Agencies</th>
                <th style="${thStyle}">Expected Outcome / Timeline</th>
              </tr>
            </thead>
            <tbody>
              ${validRows
          .map(
            (row) =>
              `<tr>${cell(row.issue)}${cell(row.proposed_action)}${cell(row.lead_agency)}${cell(row.supporting_agencies)}${cell(row.expected_outcome_timeline)}</tr>`,
          )
          .join("")}
            </tbody>
          </table>
        </div>`;
    };

    const hasOtherSuggestions = hasActualData(otherSuggestions);

    // ---------------------------------------------------------
    // LOGO
    // ---------------------------------------------------------
    const getImageAsBase64 = async (imageUrl) => {
      try {
        const response = await fetch(imageUrl);
        if (!response.ok)
          throw new Error(`Failed to load image: ${response.status}`);
        const blob = await response.blob();
        return await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        console.error("Logo loading failed:", error);
        return "";
      }
    };

    const logoBase64 = await getImageAsBase64(
      `${window.location.origin}/images/nitiaayog.png`,
    );
    console.log("NITI Aayog logo loaded:", logoBase64 ? "YES" : "NO");

    const status = safeText(currentServiceStatus).trim();
    const isProbationer =
      status.toLowerCase() === "probationer" || status === "1";
    const postingLabel = isProbationer
      ? "Training Institute / Academy"
      : "Current Posting";
    const postingValue = isProbationer ? trainingInstitute : currentPosting;

    // ---------------------------------------------------------
    // PDF HTML
    // ---------------------------------------------------------
    const html = `
      <style>
        * { box-sizing: border-box; }
        html, body { margin: 0; padding: 0; background: #ffffff; }

        .pdf-document { width: 794px; min-height: 1123px; padding: 15mm; margin: 0; background: #ffffff; color: #111111; font-family: "Times New Roman", Times, serif; font-size: 11pt; line-height: 1.25; }

        /* HEADER */
        .pdf-header { text-align: center; margin-bottom: 32px; padding-top: 4px; }
        .logo-wrapper { text-align: center; height: 100px; margin-bottom: 18px; display: flex; justify-content: center; align-items: center; }
        .logo { width: 82px; height: 72px; object-fit: contain; display: block; }
        .main-title, .sub-title { font-family: "Times New Roman", Times, serif; font-size: 14pt; font-weight: 700; line-height: 1.25; text-align: center; display: block; color: #000000; }
        .main-title { margin: 0; padding: 0; }
        .sub-title { margin-top: 6pt; }

        /* SECTION HEADINGS */
        .section-title { font-family: "Times New Roman", Times, serif; font-size: 12pt; font-weight: 700; margin-top: 14pt; margin-bottom: 6pt; line-height: 1.25; }

        /* OFFICER DETAILS */
        .officer-details { margin: 0; padding-left: 28px; font-family: "Times New Roman", Times, serif; font-size: 11pt; line-height: 1.25; }
        .officer-details li { margin-bottom: 3pt; padding-left: 1px; }
        .officer-details strong { font-weight: 700; }

        /* FEEDBACK SECTION */
        .feedback-section { margin-top: 9pt; margin-bottom: 0; padding-bottom: 0; }
        .question-title { font-family: "Times New Roman", Times, serif; font-size: 12pt; font-weight: 700; line-height: 1.25; margin-top: 10pt; margin-bottom: 8pt; padding: 0; }
        .question-note { font-size: 11pt; font-style: italic; color: #666666; line-height: 1.25; margin-top: 0; margin-bottom: 6pt; }

        /* RICH CONTENT */
        .rich-content { font-family: "Times New Roman", Times, serif; font-size: 11pt; line-height: 1.25; color: #222222; word-wrap: break-word; overflow-wrap: break-word; margin-left: 30px; margin-top: 0; padding: 0; }
        .rich-content p { margin-top: 0; margin-bottom: 6pt; padding: 0; }
        .rich-content img { width: 180px; max-width: 180px; height: auto; display: block; margin: 6pt 0; }
        .rich-content ul, .rich-content ol { margin-top: 3px; margin-bottom: 6pt; padding-left: 40px; }
        .rich-content li { margin-bottom: 3px; padding-left: 3px; }
        .rich-content li ul, .rich-content li ol { padding-left: 30px; }
        .rich-content table { width: 100%; border-collapse: collapse; margin-top: 8px; margin-bottom: 10px; }
        .rich-content th, .rich-content td { border: 1px solid #999999; padding: 5px 7px; vertical-align: top; font-size: 10.5pt; line-height: 1.25; }
        .rich-content th { font-weight: 700; background: #f3f3f3; }
        .empty-content { color: #777777; font-style: italic; margin: 0; }

        /* SUB TOPICS */
        .sub-topic-section { margin-left: 30px; margin-top: 4pt; margin-bottom: 8pt; font-family: "Times New Roman", Times, serif; font-size: 11pt; line-height: 1.25; }
        .sub-topic-label { font-weight: 700; margin-bottom: 3pt; }
        .sub-topic-list { margin-top: 2pt; margin-bottom: 0; padding-left: 28px; }
        .sub-topic-list li { margin-bottom: 3pt; padding-left: 3px; line-height: 1.25; }

        /* TOPIC 1 - SUB TOPIC FEEDBACK */
        .topic1-feedback-wrapper { margin-top: 8pt; }
        .topic1-subtopic { margin-left: 30px; margin-bottom: 16pt; page-break-inside: avoid; break-inside: avoid; }
        .topic1-subtopic-title { font-size: 11.5pt; font-weight: 700; margin-top: 8pt; margin-bottom: 6pt; line-height: 1.3; }
        .topic1-question { margin-left: 18px; margin-top: 5pt; margin-bottom: 6pt; }
        .topic1-question-title { font-size: 11pt; font-weight: 700; margin-bottom: 2pt; }
        .topic1-content { margin-left: 18px; }

        /* SUGGESTED ACTION MATRIX */
        .suggested-action-matrix { margin-top: 4pt; margin-bottom: 8pt; }
        .action-matrix-table { width: 100%; table-layout: fixed; border-collapse: separate !important; border-spacing: 0 !important; border-top: 1px solid #000 !important; border-left: 1px solid #000 !important; font-family: "Times New Roman", Times, serif; font-size: 10pt; }
        .action-matrix-table th, .action-matrix-table td { border-right: 1px solid #000 !important; border-bottom: 1px solid #000 !important; border-top: none !important; border-left: none !important; padding: 6px 8px; vertical-align: top; text-align: left; line-height: 1.25; word-wrap: break-word; overflow-wrap: break-word; background: #fff; }
        .action-matrix-table th { font-weight: 700; text-align: center; background: #f3f3f3; }
        .action-matrix-table td p { margin: 0; }
        .action-matrix-table td ul, .action-matrix-table td ol { margin: 2pt 0; padding-left: 16px; }
        .action-matrix-table th:nth-child(1), .action-matrix-table td:nth-child(1) { width: 18%; }
        .action-matrix-table th:nth-child(2), .action-matrix-table td:nth-child(2) { width: 25%; }
        .action-matrix-table th:nth-child(3), .action-matrix-table td:nth-child(3) { width: 18%; }
        .action-matrix-table th:nth-child(4), .action-matrix-table td:nth-child(4) { width: 21%; }
        .action-matrix-table th:nth-child(5), .action-matrix-table td:nth-child(5) { width: 18%; }
      </style>

      <div class="pdf-document">

        <!-- HEADER -->
        <div class="pdf-header">
          ${logoBase64 ? `<div class="logo-wrapper"><img class="logo" src="${logoBase64}" alt="NITI Aayog" /></div>` : ""}
          <div class="main-title">Sixth National Conference of Chief Secretaries</div>
          <div class="sub-title">Feedback Note</div>
        </div>

        <!-- SECTION 1 -->
        <div class="section-title">Section 1: Officer Name and Details</div>
        <ul class="officer-details">
          <li><strong>Name:</strong> ${escapeHtml(fname)}</li>
          <li><strong>Designation:</strong> ${escapeHtml(designation)}</li>
          <li><strong>Batch:</strong> ${escapeHtml(batchYear)}</li>
          <li><strong>Current Service Status:</strong> ${escapeHtml(currentServiceStatus)}</li>
          <li><strong>${escapeHtml(postingLabel)}:</strong> ${escapeHtml(postingValue)}</li>
        </ul>

        <!-- SECTION 2 -->
        <div class="section-title">Section 2: Feedback for Sixth National Conference of Chief Secretaries</div>

        <!-- QUESTION 1 -->
        <div class="feedback-section">
          <div class="question-title">1. Name of the Topic</div>
          <div class="rich-content">${getRichContent(nameOfTopic)}</div>
          ${!topic1Feedback?.length ? getSubTopicsHtml() : ""}
        </div>

        ${Array.isArray(topic1Feedback) && topic1Feedback.length > 0
        ? // TOPIC 1: per-sub-topic feedback
        getTopic1FeedbackHtml()
        : // TOPIC 2, 3, 4: normal feedback
        `
              <div class="feedback-section">
                <div class="question-title">2. Policy Gaps and Challenges</div>
                <div class="rich-content">${getRichContent(pgapsAndChallenges)}</div>
              </div>

              <div class="feedback-section">
                <div class="question-title">3. Potential Solutions</div>
                <div class="rich-content">${getRichContent(potentialSol)}</div>
              </div>

              <div class="feedback-section">
                <div class="question-title">4. Best Practices</div>
                <div class="rich-content">${getRichContent(bestPractices)}</div>
              </div>

              ${Number(data?.topicValue) === 2
          ? getSuggestedActionMatrixHtml()
          : hasOtherSuggestions
            ? `<div class="feedback-section">
                         <div class="question-title">5. Other Suggestions</div>
                         <div class="rich-content">${getRichContent(otherSuggestions)}</div>
                       </div>`
            : ""
        }
            `
      }
      </div>`;

    // ---------------------------------------------------------
    // PDF CONTAINER
    // ---------------------------------------------------------
    container = document.createElement("div");
    container.id = "pdf-render-container";
    container.innerHTML = html;
    Object.assign(container.style, {
      position: "fixed",
      left: "-10000px",
      top: "0",
      width: "794px",
      margin: "0",
      padding: "0",
      backgroundColor: "#ffffff",
      display: "block",
      visibility: "visible",
      opacity: "1",
      pointerEvents: "none",
      overflow: "visible",
    });
    document.body.appendChild(container);

    // ---------------------------------------------------------
    // WAIT FOR RENDER + IMAGES
    // ---------------------------------------------------------
    await new Promise((resolve) =>
      requestAnimationFrame(() => requestAnimationFrame(resolve)),
    );
    await new Promise((resolve) => setTimeout(resolve, 500));

    const images = container.querySelectorAll("img");
    console.log("PDF images found:", images.length);

    await Promise.all(
      Array.from(images).map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete && img.naturalWidth > 0) return resolve();
            img.onload = () => resolve();
            img.onerror = () => {
              console.warn(
                "PDF image failed to load:",
                img.src.substring(0, 100),
              );
              resolve();
            };
          }),
      ),
    );

    // One more render cycle
    await new Promise((resolve) => setTimeout(resolve, 300));

    Array.from(images).forEach((img, index) => {
      console.log(`PDF Image ${index + 1}:`, {
        src: img.src.substring(0, 80),
        complete: img.complete,
        naturalWidth: img.naturalWidth,
        naturalHeight: img.naturalHeight,
      });
    });

    // ---------------------------------------------------------
    // GET DOCUMENT + CALCULATE HEIGHT
    // ---------------------------------------------------------
    const pdfDocument = container.querySelector(".pdf-document");
    if (!pdfDocument) throw new Error("PDF document was not created.");

    const contentWidth = 794;
    const contentHeight = Math.max(
      pdfDocument.scrollHeight,
      pdfDocument.offsetHeight,
      1123,
    );

    container.style.width = `${contentWidth}px`;
    container.style.height = `${contentHeight}px`;
    pdfDocument.style.width = `${contentWidth}px`;
    pdfDocument.style.minHeight = `${contentHeight}px`;
    pdfDocument.style.height = `${contentHeight}px`;

    console.log("PDF width:", contentWidth);
    console.log("PDF height:", contentHeight);

    // ---------------------------------------------------------
    // HTML2CANVAS
    // ---------------------------------------------------------
    const canvasScaleFactor = 2;

    const canvas = await html2canvas(container, {
      scale: canvasScaleFactor,
      useCORS: true,
      allowTaint: false,
      backgroundColor: "#ffffff",
      logging: false,
      x: 0,
      y: 0,
      width: contentWidth,
      height: contentHeight,
      scrollX: 0,
      scrollY: 0,
      windowWidth: contentWidth,
      windowHeight: contentHeight,
    });

    if (!canvas || canvas.width <= 0 || canvas.height <= 0) {
      throw new Error(`Invalid canvas: ${canvas?.width} x ${canvas?.height}`);
    }

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
      compress: true,
    });

    const pageWidth = 210;
    const pageHeight = 297;
    const imgWidth = pageWidth;

    // ---------------------------------------------------------
    // SAFE BREAK POINTS
    // ---------------------------------------------------------
    const getSafeBreakPointsPx = (pdfDocumentEl, scaleFactor) => {
      const rootRect = pdfDocumentEl.getBoundingClientRect();

      const blockSelectors = [
        ".pdf-header",
        ".officer-details li",
        ".feedback-section",
        ".topic1-question",
        ".question-note",
        ".rich-content > *",
        ".rich-content li",
        ".rich-content tr",
        ".action-matrix-table tbody tr", // rows of the matrix table
        ".suggested-action-matrix", // end of the whole matrix block
      ].join(", ");

      const breaks = new Set([0]);

      pdfDocumentEl.querySelectorAll(blockSelectors).forEach((el) => {
        const bottom = Math.round(
          (el.getBoundingClientRect().bottom - rootRect.top) * scaleFactor,
        );
        if (bottom > 0) breaks.add(bottom);
      });

      breaks.add(Math.round(pdfDocumentEl.scrollHeight * scaleFactor));

      return Array.from(breaks).sort((a, b) => a - b);
    };

    const cropCanvas = (sourceCanvas, sy, sh) => {
      const cropped = document.createElement("canvas");
      cropped.width = sourceCanvas.width;
      cropped.height = sh;

      const ctx = cropped.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, cropped.width, cropped.height);
      ctx.drawImage(
        sourceCanvas,
        0,
        sy,
        sourceCanvas.width,
        sh,
        0,
        0,
        sourceCanvas.width,
        sh,
      );

      return cropped;
    };

    // ---------------------------------------------------------
    // ADD PAGES
    // ---------------------------------------------------------
    const marginMm = 15;
    const mmPerCanvasPx = pageWidth / canvas.width;
    const breakPoints = getSafeBreakPointsPx(pdfDocument, canvasScaleFactor);

    let cursor = 0;
    let pageIndex = 0;

    while (cursor < canvas.height - 1) {
      const topMarginMm = pageIndex === 0 ? 0 : marginMm;
      const remainingPx = canvas.height - cursor;

      const fitsWithoutReservedBottomMargin =
        remainingPx * mmPerCanvasPx + topMarginMm <= pageHeight;
      const bottomMarginMm = fitsWithoutReservedBottomMargin ? 0 : marginMm;

      const availablePx =
        (pageHeight - topMarginMm - bottomMarginMm) / mmPerCanvasPx;
      const limit = cursor + availablePx;

      let cut = breakPoints.filter((b) => b > cursor && b <= limit).pop();
      if (!cut) cut = Math.min(limit, canvas.height);

      const sliceHeight = Math.min(cut - cursor, canvas.height - cursor);
      const pageImageData = cropCanvas(canvas, cursor, sliceHeight).toDataURL(
        "image/jpeg",
        0.98,
      );
      const sliceHeightMm = sliceHeight * mmPerCanvasPx;

      if (pageIndex > 0) pdf.addPage();

      pdf.addImage(
        pageImageData,
        "JPEG",
        0,
        topMarginMm,
        imgWidth,
        sliceHeightMm,
        undefined,
        "FAST",
      );

      cursor = cut;
      pageIndex += 1;
    }

    // Return the PDF as a Blob. This does NOT download the file.
    const pdfBlob = pdf.output("blob");

    if (!(pdfBlob instanceof Blob) || pdfBlob.size === 0) {
      throw new Error("PDF generation returned an empty or invalid Blob");
    }

    console.log("PDF Blob generated successfully:", {
      size: pdfBlob.size,
      type: pdfBlob.type,
    });

    return pdfBlob;
  } catch (error) {
    console.error("PDF Blob generation failed:", error);
    console.error("PDF generation error stack:", error?.stack);
    throw error;
  } finally {
    if (container && container.parentNode) {
      container.parentNode.removeChild(container);
    }
    console.log("PDF temporary elements cleaned");
  }
};

export const user = "FILES_DES";
// export const file_pwd = "@p$hcl@2k26";
// export const portal_pwd = "Sw@kp!@2047";
